<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		
		<el-page-header @back="goBack" :content="from.name">
		</el-page-header>
		<!-- 表格 -->
		<div class="mt-3 " style="padding-bottom:20px">
			 <el-tabs v-model="activeName" >
			    <el-tab-pane :label="$t('live.info')" name="1">
					<el-card class="box-card">
						 <div slot="header" class="clearfix">
						    <span class="body_head">{{$t('live.info')}}</span>
					<el-button @click="openModel(info,1)" style="float: right; padding: 3px 0" type="text">{{$t('cdnd.edit')}}</el-button>
						  </div>
					  <el-descriptions labelClassName="my-label" contentClassName="my-con" :column="1">
						    <el-descriptions-item  :label="$t('cdn.domain')">{{from.name}}</el-descriptions-item>
						  
						  <el-descriptions-item :label="$t('cdn.cname')">
			  
								  <div  >
									<i class="el-icon-warning-outline mr-1" :class="info.cname_status==1?'text-success':'text-danger'"  style="font-size: 18px;"></i>	
									<span class="mb-4">{{ info.cname }}</span>
									
									
									<span class="iconCopy" @click="copyText(info.cname)"><i class="iconfont icon-fuzhi"></i></span>
								  </div>
						  </el-descriptions-item>
						  
						  
						  <el-descriptions-item :label="$t('live.type')">
						  	<span  v-if="info.type==1" >{{$t('live.type1')}}</span>
						  	<span v-if="info.type==2" >{{$t('live.type2')}}</span>
						  							 
						  </el-descriptions-item>
						  
						  
						  <el-descriptions-item  :label="$t('live.up_regoin')">
						  	<span v-if="info.up_regoin==1">{{$t('live.ChineseMainland')}}</span>
						  	<span v-if="info.up_regoin==2">{{$t('live.Global')}}</span>
						  	<span v-if="info.up_regoin==3">{{$t('live.gaAndAbroad')}}</span>
						  	
						  </el-descriptions-item> 
						  
						  
						  
						  <el-descriptions-item :label="$t('live.cloud')">
						  	{{info.cloud_name}}
						  </el-descriptions-item> 
						  
						  
						  <el-descriptions-item v-if="from.type==1" :label="$t('accountList.getUser')">
							  <el-link @click="layout.openUserInfo(info.uid)" type="primary" class="text_chengse">{{info.user_name}}</el-link>
						  </el-descriptions-item>
						  
						  
						  <el-descriptions-item v-if="from.type==2" :label="$t('live.bindTl')">
						  		{{info.bind_domain}}
						  </el-descriptions-item>
						  
						  
					    
					      <!-- <el-descriptions-item :label="$t('status.status')">
							  <span style="color: #999;" v-if="info.status==2">{{$t('cdn.status2')}}</span>
							  <span class="text-success" v-if="info.status==1">{{$t('cdn.status1')}}</span>
							  <span class="text-danger" v-if="info.status==0">{{$t('cdn.status0')}}</span>
						  </el-descriptions-item> -->
					     
					    
					      <!-- <el-descriptions-item :label="$t('cdnd.https')">
							  <span v-if="info.ssl_status==1">{{$t('cdnd.open')}}</span>
							  <span v-if="info.ssl_status==0">{{$t('cdnd.close')}}</span>
						  </el-descriptions-item> -->
						 
						  <el-descriptions-item :label="$t('live.sort')">
						  		<span>{{info.sort}}</span>
						  </el-descriptions-item> 
						  
						  <el-descriptions-item :label="$t('live.status')">
						  		<el-button  
						  			:type="info.user_status ? 'success' : 'danger'" 
						  			size="mini"
						  			@click="changeStatus(info,'user_status')"
						  			plain>{{info.user_status ? $t('live.status1') : $t('live.status2')}}
						  		</el-button>
						  </el-descriptions-item> 
						  
						  
						  <el-descriptions-item :label="$t('cdn.remark')">
						  		<span>{{info.remark}}</span>
						  </el-descriptions-item> 
						  
						  
						 
						  
						  
						  <el-descriptions-item :label="$t('adminList.createTime')">
						  		<span>{{info.create_time}}</span>
						  </el-descriptions-item>
					  </el-descriptions>
					</el-card>
					
					
					
					
				</el-tab-pane>
			    <el-tab-pane :label="from.type==1?$t('live.pushSet'):$t('live.pullSet')" name="2">
					<!-- <el-card class="box-card">
						 <div slot="header" class="clearfix">
						    <span class="body_head">{{from.type==1?$t('live.pushJX'):$t('live.pullJX')}}</span>
							
						  </div>
						  
						  <el-descriptions labelClassName="my-label" contentClassName="my-con" :column="1">
						  	<el-descriptions-item  :label="$t('cdn.domain')">{{from.name}}</el-descriptions-item>
						  						  
						  						
						  						  
						  						  
						  						
						  </el-descriptions>
					  
					</el-card> -->
					
					<!-- 鉴权配置 -->
					<el-card class="box-card mt-3">
						 <div slot="header" class="clearfix">
						    <span class="body_head">{{$t('live.domainKey')}}</span>
							<el-button @click="openModel(info,2)" style="float: right; padding: 3px 0" type="text">{{$t('cdnd.edit')}}</el-button>
						  </div>
						  
						  <el-descriptions labelClassName="my-label" contentClassName="my-con" :column="1">
						  	<el-descriptions-item  :label="$t('live.urlKey')">
								<span class="text-success" v-if="info.url_auth==1">{{$t('cdnd.open')}}</span>
								<span class="text-danger" v-if="info.url_auth==0">{{$t('cdnd.close')}}</span>
							</el-descriptions-item>
							
							<el-descriptions-item  :label="$t('live.zKey')">
								{{info.zKey}}
							</el-descriptions-item>
							
							<el-descriptions-item  :label="$t('live.fKey')">
								{{info.fKey}}
							</el-descriptions-item>
							
							<el-descriptions-item  :label="$t('live.time')">
								{{info.time}}
							</el-descriptions-item>
						  						  
						  						
						  						  
						  						  
						  						
						  </el-descriptions>
					  
					</el-card>
				
					<!-- 地址生成器 -->
					<el-card class="box-card mt-3">
						 <div slot="header" class="clearfix">
						    <span class="body_head">{{from.type==1?$t('live.pushAdd'):$t('live.pullAdd')}}</span>
							
						  </div>
						  
						  
						  <p @click="apiModel = true" style="cursor: pointer;color: rgb(64, 158, 255);font-size: 14px;">
							  
							  <i class="el-icon-warning-outline mr-1"></i>{{$t('live.apiTis')}}
						  </p>
						  
						  <el-descriptions labelClassName="my-label" contentClassName="my-con" :column="1">
						  	<el-descriptions-item  :label="from.type==1?$t('live.type1'):$t('live.type2')">{{from.name}}</el-descriptions-item>
							
							<el-descriptions-item  :label="$t('live.urlKey')">
								<span class="text-success" v-if="info.url_auth==1">{{$t('cdnd.open')}}</span>
								<span class="text-danger" v-if="info.url_auth==0">{{$t('cdnd.close')}}</span>
							</el-descriptions-item>
							
							
							<el-descriptions-item  :label="$t('live.key')">
								{{info.zKey}}
							</el-descriptions-item>
							
							
							<!-- <el-descriptions-item v-if="from.type==1" :label="$t('live.return')">
								{{info.back_status?info.back_url:'-'}}
							</el-descriptions-item> -->
							
							
							<!-- AppName -->
							<!-- <el-descriptions-item>
								<template slot="label">
									
									AppName
								  </template>
								<el-input  v-model="urlData.app_name" :placeholder="$t('live.inpAppName')" clearable size="mini" style="width: 250px;"></el-input>
							</el-descriptions-item> -->
							
							<el-descriptions-item v-if="from.type==2">
								<template slot="label">
									
									<span class="text-danger mr-1">*</span>{{$t('live.playType')}}
								  </template>
								<el-radio-group @change="changeUrlType" v-model="urlData.type">
								    <el-radio :label="1">{{$t('live.playType1')}}</el-radio>
								    <el-radio :label="2">{{$t('live.playType2')}}</el-radio>
								    <el-radio :label="3">{{$t('live.playType3')}}</el-radio>
								  </el-radio-group>
							</el-descriptions-item>
							
							<!-- StreamName -->
							<el-descriptions-item>
								<template slot="label">
									
									<span class="text-danger mr-1">*</span>StreamName
								  </template>
								<el-input  v-model="urlData.stream_name" :placeholder="$t('live.inpStreamName')" clearable size="mini" style="width: 250px;"></el-input>
								<span v-if="urlData.type!=1 " class="mx-2">_</span>
								<el-select v-if="urlData.type==2" v-model="urlData.model_name" size="mini" :placeholder="$t('live.seltranModel')">
									<el-option v-for="item in info.sel_tran_list" :key="item.id" :label="item.s_name" :value="item.s_name">
									</el-option>
								</el-select>
								<el-select v-if="urlData.type==3" v-model="urlData.model_name" size="mini" :placeholder="$t('live.seltranModel')">
									<el-option v-for="item in info.sel_ztran_list" :key="item.id" :label="item.s_name" :value="item.s_name">
									</el-option>
								</el-select>
							</el-descriptions-item>
							
							
							<!-- 有效时间 -->
							<el-descriptions-item class="mt-2">
								<template slot="label">
									
									<span class="text-danger mr-1">*</span>{{$t('live.time')}}
								  </template>
								<el-input-number size="mini" v-model="urlData.time"  :min="60" :max="info.time" :label="$t('live.time')"></el-input-number>
							</el-descriptions-item>
							
							
							
							
							
							
							
							
						  						
						  						  
						  						  
						  						
						  </el-descriptions>
						  
						  <hr>
						  
						  
						  <el-button type="primary" size="small" :disabled="urlData.load" :loading="urlData.load"  @click="getLiveUrl" >{{$t('live.addAddRess')}}</el-button>
						  
						  <hr>
						  
						  <!-- 地址结果 -->
						  
						  <div v-if="urlShow.status==1">
							  <div class="mb-2">
							  <span class="font-weight-bold mr-2" style="font-size: 16px;">{{$t('live.res_url')}}</span>
							  <span >{{$t('live.res_tis')}}</span>
							  							
							  </div>
							  
							  <el-descriptions labelClassName="my-label" contentClassName="my-con" :column="1">
							  	<el-descriptions-item  :label="$t('live.urlType')">{{from.type==1?$t('live.type1'):$t('live.type2')}}</el-descriptions-item>
							  							
							<el-descriptions-item  :label="$t('live.end_time')">
							
							{{urlShow.end_time}}
							</el-descriptions-item>
							
							<el-descriptions-item  :label="$t('live.rtmp')" v-if="urlData.type!=3">
								{{urlShow.rtmp}}
								<span class="iconCopy" @click="copyText(urlShow.rtmp)"><i class="iconfont icon-fuzhi"></i></span>
							
							</el-descriptions-item>
							
							<el-descriptions-item v-if="info.type==1" :label="$t('live.obs_server')">
								{{urlShow.obs_server}}
								<span class="iconCopy" @click="copyText(urlShow.obs_server)"><i class="iconfont icon-fuzhi"></i></span>
							
							</el-descriptions-item>
							
							
							<el-descriptions-item v-if="info.type==1" :label="$t('live.obs_value')">
								{{urlShow.obs_value}}
								<span class="iconCopy" @click="copyText(urlShow.obs_value)"><i class="iconfont icon-fuzhi"></i></span>
							
							</el-descriptions-item>
							
							
							<el-descriptions-item v-if="info.type==2  && urlData.type!=3"  :label="$t('live.flv_url')">
								{{urlShow.flv_url}}
								<span class="iconCopy" @click="copyText(urlShow.flv_url)"><i class="iconfont icon-fuzhi"></i></span>
							
							</el-descriptions-item>
							
							<el-descriptions-item v-if="info.type==2"  :label="$t('live.hls_url')">
								{{urlShow.hls_url}}
								<span class="iconCopy" @click="copyText(urlShow.hls_url)"><i class="iconfont icon-fuzhi"></i></span>
							
							</el-descriptions-item>
							
							
							<el-descriptions-item  v-if="(info.cloud_id==1 || info.cloud_id==4 || info.cloud_id==21)   && urlData.type!=3"  :label="$t('live.srt_url')">
								{{urlShow.webrtc}}
								<span class="iconCopy" @click="copyText(urlShow.webrtc)"><i class="iconfont icon-fuzhi"></i></span>
							
							</el-descriptions-item>
							
							
							
							  							
							  							
							  						  
							  						
							  </el-descriptions>
						  </div>
						  
						  
						  
						  
					  
					</el-card>
				
				</el-tab-pane>
			    <el-tab-pane :label="$t('live.modelSet')" name="3">
					<!-- 回调配置 -->
					<el-card class="box-card mt-3" v-if="from.type==1">
						 <div slot="header" class="clearfix">
						    <span class="body_head">{{$t('live.returnSet')}}</span>
							<el-button @click="openModel(info,3)" style="float: right; padding: 3px 0" type="text">{{$t('cdnd.edit')}}</el-button>
						  </div>
						  
						  <el-descriptions labelClassName="my-label" contentClassName="my-con" :column="1">
						  	<el-descriptions-item  :label="$t('live.returnOpen')">
								<span class="text-success" v-if="info.back_status">{{$t('cdnd.open')}}</span>
								<span class="text-danger" v-if="!info.back_status">{{$t('cdnd.close')}}</span>
							</el-descriptions-item>
							
							
							
							<el-descriptions-item v-if="info.back_status"  :label="$t('live.returnKeyStatus')">
								<span class="text-success" v-if="info.back_key_status">{{$t('cdnd.open')}}</span>
								<span class="text-danger" v-if="!info.back_key_status">{{$t('cdnd.close')}}</span>
							</el-descriptions-item>
							
							<el-descriptions-item v-if="info.back_status" :label="$t('live.returnKey')">
								{{info.back_key}}
							</el-descriptions-item>
							
							
							
							<el-descriptions-item v-if="info.back_status" :label="$t('live.pushBack')">
								{{info.streamStartUrl}}
							</el-descriptions-item>
							<el-descriptions-item v-if="info.back_status" :label="$t('live.pushEndBack')">
								{{info.streamEndUrl}}
							</el-descriptions-item>
							<el-descriptions-item v-if="info.back_status" :label="$t('live.imgBack')">
								{{info.imgUrl}}
							</el-descriptions-item>
							<el-descriptions-item v-if="info.back_status" :label="$t('live.recordFileBack')">
								{{info.recordFileUrl}}
							</el-descriptions-item>
							<el-descriptions-item v-if="info.back_status" :label="$t('live.recordStatusBack')">
								{{info.recordStatusUrl}}
							</el-descriptions-item>
						  						  
												  
						  						
						  						  
						  						  
						  						
						  </el-descriptions>
						  
						  <hr>
						  <div class="">
							  <div>
								  <el-tag type="success">{{$t('live.returnKeyStatus')}}</el-tag>
							  </div>
							  
							  <div class="mt-3 ml-3 call_tis" >
								  {{$t('live.signTis')}}
								  
							  </div>
							  
							  
						  </div>
					  
					</el-card>
					
					<!-- 截图设置 -->
					<el-card class="box-card mt-3" v-if="from.type==1">
						 <div slot="header" class="clearfix">
						    <span class="body_head">{{$t('live.imgSet')}}</span>
							<el-button @click="openModel(info,7)" style="float: right; padding: 3px 0" type="text">{{$t('cdnd.edit')}}</el-button>
						  </div>
						  
						  <el-descriptions labelClassName="my-label" contentClassName="my-con" :column="1">
							  <el-descriptions-item  :label="$t('live.imgSet')">
								 <span class="text-success" v-if="info.img_status">{{$t('cdnd.open')}}</span>
								 <span class="text-danger" v-if="!info.img_status">{{$t('cdnd.close')}}</span>
							  </el-descriptions-item>
							  
							  <el-descriptions-item v-if="info.img_status" :label="$t('live.imgTime')">
							  	{{info.img_time}}
							  </el-descriptions-item>
								
						  </el-descriptions>
						  
						
					  
					</el-card>
					
					<!-- 录制设置 -->
					<el-card class="box-card mt-3" v-if="from.type==1">
						 <div slot="header" class="clearfix">
						    <span class="body_head">{{$t('live.recordSet')}}</span>
							<el-button @click="openModel(info,8)" style="float: right; padding: 3px 0" type="text">{{$t('cdnd.edit')}}</el-button>
						  </div>
						  
						  <el-table
						  	        :data="info.sel_record_list"
						  	        style="width: 100%">
						  	        <el-table-column prop="name" align="center" :label="$t('live.modelName')" >
						  				<template slot-scope="scope">
						  					{{scope.row.key}}{{scope.row.name}}
						  				</template>
						  			</el-table-column>
						  	       
						  		  
								  
								  <el-table-column  prop="date" align="center" label="HLS" >
								  	   <template slot-scope="scope">
								  			<span class="text-success" v-if="scope.row.data.hlsStatus==1">{{$t('cdnd.open')}}</span>
								  			<span class="text-danger" v-if="scope.row.data.hlsStatus==0">{{$t('cdnd.close')}}</span>
								  	   </template>
								  </el-table-column>
								  
								  <el-table-column  prop="date" align="center" label="FLV" >
								  	   <template slot-scope="scope">
								  			<span class="text-success" v-if="scope.row.data.flvStatus==1">{{$t('cdnd.open')}}</span>
								  			<span class="text-danger" v-if="scope.row.data.flvStatus==0">{{$t('cdnd.close')}}</span>
								  	   </template>
								  </el-table-column>
								  
								  <el-table-column  prop="date" align="center" label="MP4" >
								  	   <template slot-scope="scope">
								  			<span class="text-success" v-if="scope.row.data.mp4Status==1">{{$t('cdnd.open')}}</span>
								  			<span class="text-danger" v-if="scope.row.data.mp4Status==0">{{$t('cdnd.close')}}</span>
								  	   </template>
								  </el-table-column>
						  		   
						  		 
						  		  
						  		   
						  
						  	      </el-table>
						  	  
						  	
						    
						  </el-card>
						  
						  
						  
						
					  
					</el-card>
					
					
					<!-- 直播水印 -->
					<el-card class="box-card mt-3" v-if="from.type==1" >
						 <div slot="header" class="clearfix">
						    <span class="body_head">{{$t('live.liveSy')}}</span>
							<el-button @click="openModel(info,13)" style="float: right; padding: 3px 0" type="text">{{$t('cdnd.edit')}}</el-button>
						  </div>
						  
						  <div class="new_show_form">
							  <el-form label-position="left" label-width="130px" >
							    <el-form-item :label="$t('live.liveSy')">
									<span class="text-success" v-if="info.sy_status">{{$t('cdnd.open')}}</span>
									<span class="text-danger" v-if="!info.sy_status">{{$t('cdnd.close')}}</span>
								
							    </el-form-item>

							  </el-form>
						  </div>
					
					</el-card>
					
					
					<!-- 文件生命周期 -->
					<el-card class="box-card mt-3" v-if="from.type==1" >
						 <div slot="header" class="clearfix">
						    <span class="body_head">{{$t('live.Referer3')}}</span>
							<el-button @click="openModel(info,12)" style="float: right; padding: 3px 0" type="text">{{$t('cdnd.edit')}}</el-button>
						  </div>
						  
						  <div class="new_show_form">
							  <el-form label-position="left" label-width="130px" >
							    <el-form-item :label="$t('live.Referer3')">
									
									<span>{{$t('live.Referer3-1')}}
									
									<span class="text-success">{{info.fileDel_time}}</span>
									{{$t('live.Referer3-2')}}</span>
							    </el-form-item>
							  
								
							
							  </el-form>
						  </div>

					</el-card>
					
					
					<!-- 文件防盗链 -->
					<el-card class="box-card mt-3" v-if="from.type==1" >
						 <div slot="header" class="clearfix">
						    <span class="body_head">{{$t('live.Referer2')}}</span>
							<el-button @click="openModel(info,11)" style="float: right; padding: 3px 0" type="text">{{$t('cdnd.edit')}}</el-button>
						  </div>
						  
						  <div class="new_show_form">
							  <el-form label-position="left" label-width="130px" >
							    <el-form-item :label="$t('live.Referer2')">
									<span class="text-success" v-if="info.fileRef_status==1">{{$t('cdnd.open')}}</span>
									<span class="text-danger" v-if="info.fileRef_status==0">{{$t('cdnd.close')}}</span>
							    </el-form-item>
							    <el-form-item v-if="info.fileRef_status==1" :label="$t('live.RefererType')">
									{{info.fileRef_type==1?$t('live.ipType1'):$t('live.ipType2')}}
									
							    </el-form-item>
								
							    <el-form-item v-if="info.fileRef_status==1" :label="$t('live.RefererRule')">
									<div class="refov">
										<pre>{{info.fileRef_data}}</pre>
									</div>
									
									<span style="font-size: 12px;color: grey;">
									共 {{info.fileRef_data_num}} 条</span>
									
									 
							    </el-form-item>
							  </el-form>
						  </div>
						  
						  
						
						  
					
						  
					  
					</el-card>
					
					
					
					
					
					<!-- 转码设置 -->
					<el-card class="box-card mt-3" v-if="from.type==1">
						 <div slot="header" class="clearfix">
						    <span class="body_head">{{$t('live.transferSet')}}</span>
							<el-button @click="openModel(info,9)" style="float: right; padding: 3px 0" type="text">{{$t('cdnd.edit')}}</el-button>
						  </div>
						  
						  <el-table
						        :data="info.sel_tran_list"
						        style="width: 100%">
						        <el-table-column prop="name" align="center" :label="$t('live.modelName')" >
									<template slot-scope="scope">
										{{scope.row.key}}{{scope.row.name}}
									</template>
								</el-table-column>
						       
							   <el-table-column  prop="date" align="center" :label="$t('live.modelType')" >
								   <template slot-scope="scope">
										<span v-if="scope.row.video_type==1">{{$t('live.videoType1')}}</span>
										<span v-if="scope.row.video_type==2">{{$t('live.videoType2')}}</span>
								   </template>
							   </el-table-column>
							   <el-table-column  prop="date" align="center" :label="$t('live.ma_type')" >
								   <template slot-scope="scope">
										<span v-if="scope.row.code_type==264">H.264</span>
										<span v-if="scope.row.code_type==265">H.265</span>
								   </template>
							   </el-table-column>
							   <el-table-column   prop="date" align="center" :label="$t('live.videoBitrate')" >
								   <template slot-scope="scope">
										<span v-if="scope.row.ma_type==1">{{scope.row.ma_value}} kbps</span>
										<span v-if="scope.row.ma_type==2">{{$t('live.setMa2')}}</span>
								   </template>
							   </el-table-column>
							   <el-table-column width="300" prop="date" align="center" :label="$t('live.fenbianlv')"  >
								   <template slot-scope="scope">
									   <span v-if="scope.row.wh_type==1">
										   <span>{{$t('live.height')}}：{{scope.row.wh_value}} px</span>&nbsp;
										   <span>{{$t('live.width')}}</span>
									   </span>
									   <span v-if="scope.row.wh_type==2">{{$t('live.setWH2')}}</span>
									   
								   </template>
								
							   </el-table-column>
							   

						      </el-table>
						  
						
					  
					</el-card>
					
					
					
					<!-- 自适应转码 -->
					<el-card class="box-card mt-3" v-if="from.type==1">
						 <div slot="header" class="clearfix">
						    <span class="body_head">{{$t('live.zTranSet')}}</span>
							<el-button @click="openModel(info,10)" style="float: right; padding: 3px 0" type="text">{{$t('cdnd.edit')}}</el-button>
						  </div>
						  
						  <el-table
						        :data="info.sel_ztran_list"
						        style="width: 100%">
								<el-table-column  type="expand" :label="$t('liveModel.zi')">
									<template slot-scope="props">
										<el-table   stripe  :data="props.row.chil"  >
											
							
											<el-table-column width="120" align="center" prop="s_name" :label="$t('liveModel.name')">
											
											
											</el-table-column>
											
											
											
											
											
											<el-table-column   prop="date" align="center" :label="$t('live.modelType')" >
											   <template slot-scope="scope">
													<span v-if="scope.row.video_type==1">{{$t('live.videoType1')}}</span>
													<span v-if="scope.row.video_type==2">{{$t('live.videoType2')}}</span>
											   </template>
											</el-table-column>
											<el-table-column  prop="date" align="center" :label="$t('live.ma_type')" >
												   <template slot-scope="scope">
														<span v-if="scope.row.code_type==264">H.264</span>
														<span v-if="scope.row.code_type==265">H.265</span>
												   </template>
											</el-table-column>
											<el-table-column   prop="date" align="center" :label="$t('live.videoBitrate')" >
												   <template slot-scope="scope">
														<span v-if="scope.row.ma_type==1">{{scope.row.ma_value}} kbps</span>
														<span v-if="scope.row.ma_type==2">{{$t('live.setMa2')}}</span>
												   </template>
											</el-table-column>
											<el-table-column width="300" prop="date" align="center" :label="$t('live.fenbianlv')"  >
											   <template slot-scope="scope">
												   
												   <span v-if="scope.row.wh_type==1">
													   <span>{{$t('live.height')}}：{{scope.row.wh_value}} px</span>&nbsp;
													   <span>{{$t('live.width')}}</span>
												   </span>
												   <span v-if="scope.row.wh_type==2">{{$t('live.setWH2')}}</span>
												   
												   
												
												
											   </template>
																			
											</el-table-column>
											
											<el-table-column   prop="date" align="center" :label="$t('live.videoFrameRate')" >
												   <template slot-scope="scope">
														<span v-if="scope.row.z_type==1">{{scope.row.z_value}} fps</span>
														<span v-if="scope.row.z_type==2">{{$t('live.setZ2')}}</span>
												   </template>
											</el-table-column>
											
											<el-table-column   prop="date" align="center" label="GOP" >
												   <template slot-scope="scope">
														{{scope.row.gop}} s
												   </template>
											</el-table-column>
										</el-table>
									</template>
								   </el-table-column>
						        <el-table-column prop="name" align="center" :label="$t('live.modelName')" >
									<template slot-scope="scope">
										{{scope.row.key}}{{scope.row.name}}
									</template>
								</el-table-column>
						       
							   <el-table-column   prop="remark" align="center" :label="$t('liveModel.remark')" >
							   							  
							   </el-table-column>
							   
							   <el-table-column   prop="num" align="center" :label="$t('liveModel.num')" >
							   							  
							   </el-table-column>
							   
					
						      </el-table>
						  
						
					  
					</el-card>
					
					<!-- https设置 -->
					<el-card class="box-card mt-3" v-if="from.type==2">
						 <div slot="header" class="clearfix">
						    <span class="body_head">{{$t('cdnd.nav3')}}</span>
							<el-tooltip :content="$t('live.certtis')" effect="light" placement="top">
								
								<el-button size="mini" type="text">
									 <i class="el-icon-warning-outline ml-1" style="font-size: 16px;"></i>
								</el-button>
								
							</el-tooltip>
							
							<el-button @click="openModel(info,6)" style="float: right; padding: 3px 0" type="text">{{$t('cdnd.edit')}}</el-button>
						  </div>
						  
						  <el-descriptions labelClassName="my-label" contentClassName="my-con" :column="1">
							<el-descriptions-item  :label="$t('live.https')">
							 <span class="text-success" v-if="info.cert_status==1">{{$t('cdnd.open')}}</span>
							 <span class="text-danger" v-if="info.cert_status==0">{{$t('cdnd.close')}}</span>
							 <span class="text-info" v-if="info.cert_status==2">{{$t('live.inSet')}}</span>
							</el-descriptions-item>
							
							<el-descriptions-item v-if="info.cert_status == 1"  :label="$t('live.httpsEnd')">
								
								<span :style="{ color: getColor(info.cert_end) }">
								    {{info.cert_end}}
								</span>
								<el-button v-if="shouldShowButton(info.cert_end)" @click="againGetHttps(info)" class="ml-3" size="mini"  type="success">{{$t('live.againCert')}}</el-button>
							
							</el-descriptions-item>
						  </el-descriptions>
						  
						
					  
					</el-card>
					
					
					<!-- IP黑白名单 -->
					<!-- <el-card class="box-card mt-3" >
						 <div slot="header" class="clearfix">
						    <span class="body_head">{{$t('live.ipLog')}}</span>
							<el-button @click="openModel(info,4)" style="float: right; padding: 3px 0" type="text">{{$t('cdnd.edit')}}</el-button>
						  </div>
						  
						  <div class="new_show_form">
							  <el-form label-position="left" label-width="130px" >
							    <el-form-item :label="$t('live.ipLog')">
									<span class="text-success" v-if="info.ip_status==1">{{$t('cdnd.open')}}</span>
									<span class="text-danger" v-if="info.ip_status==0">{{$t('cdnd.close')}}</span>
							    </el-form-item>
							    <el-form-item v-if="info.ip_status==1" :label="$t('live.ipType')">
									{{info.ip_type==1?$t('live.ipType1'):$t('live.ipType2')}}
							    </el-form-item>
							    <el-form-item v-if="info.ip_status==1" :label="$t('live.ipData')">
									<div v-show="showAllIp || index<2" style="line-height: 14px;" class="mt-2"  v-for="(item, index) in info.ip_data" :key="index">
										{{ item }}
									</div>
									
									 <el-link @click="showAllIp= !showAllIp" v-if="" type="primary">{{!showAllIp?$t('live.open'):$t('live.shouqi')}}</el-link>
							    </el-form-item>
							  </el-form>
						  </div>
						  
						  
						
						  
					
						  
					  
					</el-card> -->
					
					
					<!-- Referer防盗链 -->
					<el-card class="box-card mt-3" v-if="from.type==2" >
						 <div slot="header" class="clearfix">
						    <span class="body_head">{{$t('live.Referer')}}</span>
							<el-button @click="openModel(info,5)" style="float: right; padding: 3px 0" type="text">{{$t('cdnd.edit')}}</el-button>
						  </div>
						  
						  <div class="new_show_form">
							  <el-form label-position="left" label-width="130px" >
							    <el-form-item :label="$t('live.Referer')">
									<span class="text-success" v-if="info.ref_status==1">{{$t('cdnd.open')}}</span>
									<span class="text-danger" v-if="info.ref_status==0">{{$t('cdnd.close')}}</span>
							    </el-form-item>
							    <el-form-item v-if="info.ref_status==1" :label="$t('live.RefererType')">
									{{info.ref_type==1?$t('live.ipType1'):$t('live.ipType2')}}
									
							    </el-form-item>
								
								<el-form-item v-if="info.ref_status==1" :label="$t('live.RefererNull')">
									<span v-if="info.ref_null_status==1">{{$t('live.yes')}}</span>
									<span v-if="info.ref_null_status==0">{{$t('live.no')}}</span>
									
								</el-form-item>
							    <el-form-item v-if="info.ref_status==1" :label="$t('live.RefererRule')">
									<div class="refov">
										<pre>{{info.ref_data}}</pre>
									</div>
									
									<span style="font-size: 12px;color: grey;">
									共 {{info.ref_data_num}} 条</span>
									
									 
							    </el-form-item>
							  </el-form>
						  </div>
						  
						  
						
						  
					
						  
					  
					</el-card>
					
					
					
				</el-tab-pane>
			    <!-- <el-tab-pane :label="$t('cdnd.nav4')" name="4">缓存配置</el-tab-pane>
			    <el-tab-pane :label="$t('cdnd.nav5')" name="5">分组配置</el-tab-pane> -->
			  </el-tabs>
		</div>


		
		

		<el-dialog :close-on-click-modal="false"
			:title="dialogTitle"
			:visible.sync="createModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'100px'">
				
				
				<div v-if="openType==1">
					<!-- 选择服务商 -->
					<el-form-item   :label="$t('live.cloud')" prop="cloud_id">
						<el-select   v-model="form.cloud_id" size="small" filterable :placeholder="$t('system.select')">
						<el-option  :label="$t('live.nosel')" :value="0">
						</el-option>
							<el-option v-for="item in agentData.cloud" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
						
					</el-form-item>
					
					
					<!-- 选择分配用户 -->
					<el-form-item v-if="form.type==1"  :label="$t('accountList.getUser')" prop="cloud_id">
						<el-select   v-model="form.uid" size="small" filterable :placeholder="$t('system.select')">
						<el-option  :label="$t('live.nosel')" :value="0">
						</el-option>
							<el-option v-for="item in agentData.user" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
						
					</el-form-item>
					
					
					<!-- 选择分配用户 -->
					<el-form-item v-if="form.type==2"  :label="$t('live.bindTl')" prop="cloud_id">
						<el-select   v-model="form.bind_id" size="small" filterable :placeholder="$t('system.select')">
						<el-option  :label="$t('live.nosel')" :value="0">
						</el-option>
							<el-option v-for="item in agentData.tl" :key="item.id" :label="item.domain" :value="item.id">
							</el-option>
						</el-select>
						
					</el-form-item>
					
					
					<!-- 加速区域 -->
					<!-- <el-form-item v-if="form.type==2" :label="$t('live.up_regoin')" prop="up_regoin">
						<el-select   v-model="form.up_regoin" size="small" filterable :placeholder="$t('system.select')">
						
							<el-option v-for="item in agentData.up" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item> -->
					
					
					<el-form-item :label="$t('live.sort2')" prop="sort">
						<el-input v-model="form.sort" :placeholder="$t('live.sort2')" clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>
					
					<el-form-item   :label="$t('live.status')">
						<el-radio-group   v-model="form.user_status" size="small">
							<el-radio :label="1" border>{{$t('live.status1')}}</el-radio>
							<el-radio :label="0" border>{{$t('live.status2')}}</el-radio>
						</el-radio-group>
					</el-form-item>
					
					
					<el-form-item :label="$t('cdn.remark')" prop="remark">
						<el-input v-model="form.remark" :placeholder="$t('cdn.remark')" clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>
				</div>
				
				
				<div v-if="openType==2">
					
					<el-form-item   :label="$t('live.urlKey')" prop="url_auth">
						<el-switch
						  v-model="form.url_auth"
						  active-color="#13ce66"
						  inactive-color="#999999">
						</el-switch>
						
					</el-form-item>
					
					<el-form-item   :label="$t('live.zKey')" prop="zKey">
						<el-input @input="checkKeyInp"  v-model="form.zKey" :placeholder="$t('live.keyTis')" clearable size="small" style="width: 55%;"></el-input>
						<el-link class="ml-3 text-info" type="success"  @click="rangKey(1)">随机生成</el-link>
						
					</el-form-item>
					
					<el-form-item   :label="$t('live.fKey')" prop="fKey">
						<el-input @input="checkKeyInp2" v-model="form.fKey" :placeholder="$t('live.keyTis')" clearable size="small" style="width: 55%;"></el-input>
						<el-link class="ml-3 text-info" type="success" @click="rangKey(2)">随机生成</el-link>
						
					</el-form-item>
					
					
					<el-form-item   :label="$t('live.time')" prop="time">
						<el-input-number v-model="form.time"  :min="60" :max="2592000" :label="$t('live.time')"></el-input-number>
						
					</el-form-item>
					
					
					
					<el-form-item v-if="!form.url_auth">
						{{$t('live.keyClostTis')}}
						
					</el-form-item>
					
					<el-form-item v-if="!form.url_auth">
						<el-checkbox v-model="form.agree">{{$t('live.keyClostTis2')}}</el-checkbox>
						
					</el-form-item>
					
				</div>
				
				
				
				<div v-if="openType==3">
					
					
					
					<el-form-item   :label="$t('live.returnOpen')" prop="url_auth">
						<el-switch
						  v-model="form.back_status"
						  active-color="#13ce66"
						  inactive-color="#999999">
						</el-switch>
						
					</el-form-item>
					
					
					
					<el-form-item  v-if="form.back_status" :label="$t('live.returnKeyStatus')" prop="back_key_status">
						<el-switch
						  v-model="form.back_key_status"
						  active-color="#13ce66"
						  inactive-color="#999999">
						</el-switch>
						
					</el-form-item>
					
					
					
					
					<el-form-item  v-if="form.back_status && form.back_key_status"  :label="$t('live.returnKey')" prop="back_key">
						<el-input @input="checkKeyInp3" v-model="form.back_key" :placeholder="$t('live.keyTis')" clearable size="small" style="width: 55%;"></el-input>
						<el-link class="ml-3 text-info" type="success" @click="rangKey(3)">{{$t('match.rand')}}</el-link>
						
					</el-form-item>
					
					
					<el-tabs class="ml-5" v-if="form.back_status" v-model="returnType" >
					    <el-tab-pane :label="$t('live.pushBack')" name="1">
							<!-- 推流回调 -->
							<el-form-item   :label="$t('live.pushBack')" >
								<el-switch
								  v-model="form.streamStartStatus"
								  active-color="#13ce66"
								  inactive-color="#999999">
								</el-switch>
								
							</el-form-item>
							
							<el-form-item v-if="form.back_status && form.streamStartStatus"  :label="$t('live.localUrl')" prop="streamStartUrl">
							
								<el-input  v-model="form.streamStartUrl" :placeholder="$t('live.return')" clearable size="small" style="width: 55%;"></el-input>
								
							</el-form-item>
						</el-tab-pane>
					    <el-tab-pane :label="$t('live.pushEndBack')" name="2">
							<!-- 断流回调 -->
							<el-form-item v-if="form.back_status" :label="$t('live.pushEndBack')" >
								<el-switch
								  v-model="form.streamEndStatus"
								  active-color="#13ce66"
								  inactive-color="#999999">
								</el-switch>
								
							</el-form-item>
							
							<el-form-item v-if="form.back_status && form.streamEndStatus"  :label="$t('live.localUrl')" prop="streamEndUrl">
							
								<el-input  v-model="form.streamEndUrl" :placeholder="$t('live.return')" clearable size="small" style="width: 55%;"></el-input>
								
							</el-form-item>
						</el-tab-pane>
					    <el-tab-pane :label="$t('live.imgBack')" name="3">
							<!-- 截图回调 -->
							<el-form-item v-if="form.back_status"  :label="$t('live.imgBack')" >
								<el-switch
								  v-model="form.imgStatus"
								  active-color="#13ce66"
								  inactive-color="#999999">
								</el-switch>
								
							</el-form-item>
							
							<el-form-item v-if="form.back_status && form.imgStatus"  :label="$t('live.localUrl')" prop="imgUrl">
							
								<el-input  v-model="form.imgUrl" :placeholder="$t('live.return')" clearable size="small" style="width: 55%;"></el-input>
								
							</el-form-item>
						</el-tab-pane>
					    <el-tab-pane :label="$t('live.recordFileBack')" name="4">
							<!-- 录制文件回调 -->
							<el-form-item v-if="form.back_status"  :label="$t('live.recordFileBack')" >
								<el-switch
								  v-model="form.recordFileStatus"
								  active-color="#13ce66"
								  inactive-color="#999999">
								</el-switch>
								
							</el-form-item>
							
							<el-form-item v-if="form.back_status && form.recordFileStatus"  :label="$t('live.localUrl')" prop="recordFileUrl">
							
								<el-input  v-model="form.recordFileUrl" :placeholder="$t('live.return')" clearable size="small" style="width: 55%;"></el-input>
								
							</el-form-item>
						</el-tab-pane>
					    <el-tab-pane :label="$t('live.recordStatusBack')" name="5">
							<!-- 录制h状态回调 -->
							<el-form-item v-if="form.back_status"  :label="$t('live.recordStatusBack')" >
								<el-switch
								  v-model="form.recordStatusStatus"
								  active-color="#13ce66"
								  inactive-color="#999999">
								</el-switch>
								
							</el-form-item>
							
							<el-form-item v-if="form.back_status && form.recordStatusStatus"  :label="$t('live.localUrl')" prop="recordStatusUrl">
							
								<el-input  v-model="form.recordStatusUrl" :placeholder="$t('live.return')" clearable size="small" style="width: 55%;"></el-input>
								
							</el-form-item>
						</el-tab-pane>
					  </el-tabs>
					
					
					
					
					
					
					
					
					
					
					
					
					
					
					
					
					
					
					
				
					
					
					
					
				
					
					
					
					
					
					
					
					
					
					
					
				
					
				</div>
				
				
				
				<div v-if="openType==4">
					
					<el-form-item   :label="$t('live.ipLog')" prop="url_auth">
						<el-switch
						  v-model="form.ip_status"
						  active-color="#13ce66"
						  inactive-color="#999999">
						</el-switch>
						
					</el-form-item>
					
					<el-form-item v-if="form.ip_status==1" :label="$t('live.ipType')">
						<el-radio-group  v-model="form.ip_type" size="small">
							<el-radio :label="1" border>{{$t('live.ipType1')}}</el-radio>
							<el-radio :label="2" border>{{$t('live.ipType2')}}</el-radio>
						</el-radio-group>
					</el-form-item>
					
					
					
					<el-form-item v-if="form.ip_status==1"  :label="$t('live.ipData')" prop="ip_data">
						<el-input  @input="handleIpInput"  v-model="form.ip_data" type="textarea" :rows="8"  :placeholder="$t('live.inpipData')" clearable size="small" style="width: 85%;"></el-input>

					</el-form-item>
					
					
					
					
				
					
					
					
					
					
					
					
				
					
				</div>
				
				<!-- 直播水印表单 -->
				<div v-if="openType==13">
					<div class="watermark-editor">
						<div class="watermark-editor__controls">
							<div class="watermark-editor__tip">
								{{ $t('live.liveSyTip') }}
							</div>
							<el-form-item   :label="$t('live.liveSy')" prop="sy_status">
								<el-switch
								  v-model="form.sy_status"
								  @change="handleWatermarkStatusChange"
								  active-color="#13ce66"
								  inactive-color="#999999">
								</el-switch>
							</el-form-item>
							<template v-if="form.sy_status">
								<el-form-item :label="$t('live.selSy')" prop="sy_url">
									<el-upload
										name="file"
										class="watermark-uploader"
										action="/admin/image/uploadNew"
										:headers="{token:$store.state.user.token}"
										:data="{type:'liveSy'}"
										:show-file-list="false"
										:on-success="handleAvatarSuccess"
										:before-upload="beforeAvatarUpload">
										<div class="watermark-uploader__inner">
											<img v-if="form.sy" :src="form.sy" class="watermark-uploader__thumb" @load="handleWatermarkPreviewLoad">
											<i v-else class="el-icon-upload2 watermark-uploader__icon"></i>
											<span class="watermark-uploader__text">{{ $t('live.selSy') }}</span>
										</div>
									</el-upload>
								</el-form-item>

								<el-form-item :label="$t('live.watermarkHorizontalOffset')">
									<div class="watermark-slider">
										<el-slider
											v-model="form.sy_x"
											:min="0"
											:max="100"
											:step="0.1"
										></el-slider>
										<div class="watermark-slider__value">{{ formatWatermarkPercent(form.sy_x) }}</div>
									</div>
								</el-form-item>

								<el-form-item :label="$t('live.watermarkVerticalOffset')">
									<div class="watermark-slider">
										<el-slider
											v-model="form.sy_y"
											:min="0"
											:max="100"
											:step="0.1"
										></el-slider>
										<div class="watermark-slider__value">{{ formatWatermarkPercent(form.sy_y) }}</div>
									</div>
								</el-form-item>

								<el-form-item :label="$t('live.watermarkScale')">
									<div class="watermark-scale">
										<el-slider
											v-model="form.sy_scale"
											:min="1"
											:max="100"
											:step="1"
										></el-slider>
										<el-input-number
											v-model="form.sy_scale"
											:min="1"
											:max="100"
											:step="1"
											:precision="0"
											controls-position="right"
										></el-input-number>
										<span class="watermark-scale__unit">%</span>
									</div>
								</el-form-item>
							</template>
						</div>

						<div v-if="form.sy_status" class="watermark-editor__preview">
							<div class="watermark-preview__toolbar">
								<div class="watermark-preview__size">
									<span class="watermark-preview__size-label">{{ $t('live.previewWindowSize') }}</span>
									<el-input-number
										v-model="form.preview_width"
										:min="1"
										:step="1"
										:precision="0"
										controls-position="right"
									></el-input-number>
									<span class="watermark-preview__size-sep">x</span>
									<el-input-number
										v-model="form.preview_height"
										:min="1"
										:step="1"
										:precision="0"
										controls-position="right"
									></el-input-number>
								</div>
							</div>

							<div
								class="watermark-preview"
								:style="watermarkPreviewStageStyle"
							>
								<div ref="watermarkPreviewScreen" class="watermark-preview__screen">
									<div
										v-if="form.sy"
										:style="watermarkPreviewImageStyle"
										class="watermark-preview__image-box"
									>
										<img
											:key="form.sy"
											:src="form.sy"
											class="watermark-preview__image"
											draggable="false"
											@dragstart.prevent
											@mousedown.prevent="startWatermarkDrag"
											@load="handleWatermarkPreviewLoad"
										>
										<span
											v-for="corner in watermarkResizeCorners"
											:key="corner.key"
											class="watermark-preview__handle"
											:class="`is-${corner.key}`"
											@mousedown.prevent.stop="startWatermarkResize($event, corner.key)"
										></span>
									</div>
									<div v-else class="watermark-preview__empty">
										{{ $t('live.watermarkPreviewEmpty') }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				
				<div v-if="openType==12">
	
					
					<el-form-item   :label="$t('live.Referer3-3')" prop="fileDel_time">

						  <el-input-number v-model="form.fileDel_time" :min="1" :max="100000" label="描述文字"></el-input-number>

					</el-form-item>
					
					
				</div>
				
				
				<div v-if="openType==11">
					
					<el-form-item   :label="$t('live.Referer2')" prop="url_auth">
						<el-switch
						  v-model="form.fileRef_status"
						  active-color="#13ce66"
						  inactive-color="#999999">
						</el-switch>
						
					</el-form-item>
					
					
					
					<el-form-item v-if="form.fileRef_status==1" :label="$t('live.RefererType')">
						<el-radio-group  v-model="form.fileRef_type" size="small">
							<el-radio :label="1" border>{{$t('live.ipType1')}}</el-radio>
							<el-radio :label="2" border>{{$t('live.ipType2')}}</el-radio>
						</el-radio-group>
					</el-form-item>
					
					
					<el-form-item v-if="form.fileRef_status==1"  :label="$t('live.RefererRule')" prop="fileRef_data">
						<el-input  @input="handleIpInput"  v-model="form.fileRef_data" type="textarea" :rows="8"  :placeholder="$t('live.inpRefererRule')" clearable size="small" style="width: 85%;"></el-input>
						<div style="font-size: 12px;color: gray;">{{$t('live.ref_max')}},多个域名请使用换行或分号（;）分隔</div>
						
					</el-form-item>
					
					
				</div>
				
				
				<div v-if="openType==5">
					
					<el-form-item   :label="$t('live.Referer')" prop="url_auth">
						<el-switch
						  v-model="form.ref_status"
						  active-color="#13ce66"
						  inactive-color="#999999">
						</el-switch>
						
					</el-form-item>
					
					
					
					<el-form-item v-if="form.ref_status==1" :label="$t('live.RefererType')">
						<el-radio-group  v-model="form.ref_type" size="small">
							<el-radio :label="1" border>{{$t('live.ipType1')}}</el-radio>
							<el-radio :label="2" border>{{$t('live.ipType2')}}</el-radio>
						</el-radio-group>
					</el-form-item>
					
					
					<el-form-item v-if="form.ref_status==1"  :label="$t('live.RefererNull')" prop="url_auth">
						<el-switch
						  v-model="form.ref_null_status"
						  active-color="#13ce66"
						  inactive-color="#999999">
						</el-switch>
						
					</el-form-item>
					
					
					
					<el-form-item v-if="form.ref_status==1"  :label="$t('live.RefererRule')" prop="ref_data">
						<el-input  @input="handleIpInput"  v-model="form.ref_data" type="textarea" :rows="8"  :placeholder="$t('live.inpRefererRule')" clearable size="small" style="width: 85%;"></el-input>
						
						<div style="font-size: 12px;color: gray;">{{$t('live.ref_max')}},多个域名请使用换行或分号（;）分隔</div>
					</el-form-item>
					
					
					
					
				
					
					
					
					
					
					
					
				
					
				</div>
				
				
				<div v-if="openType==7">
					
					<el-form-item   :label="$t('live.imgSet')" prop="url_auth">
						<el-switch
						  v-model="form.img_status"
						  active-color="#13ce66"
						  inactive-color="#999999">
						</el-switch>
						
					</el-form-item>
					
					
				
					
					
					
					<el-form-item v-if="form.img_status"  :label="$t('live.imgTime')" prop="img_time">
						<el-input-number v-model="form.img_time"  :min="5" :max="300" :label="$t('live.inpimgTime')"></el-input-number>
						
					</el-form-item>
					
					
					
					
				
					
					
					
					
					
					
					
				
					
				</div>
				
				
				<div v-if="openType==6">
					<el-form-item   :label="$t('live.https')" prop="cert_status">
						<el-switch
						  v-model="form.cert_status"
						  active-color="#13ce66"
						  inactive-color="#999999">
						</el-switch>
						
					</el-form-item>
				</div>
				
				
				<div v-show="openType==8">
					<div class="mb-3" style="display: flex;align-items: center;">{{$t('live.ztranTo')}} 
					<el-link @click="toModel" type="primary">【{{$t('router.model')}} <i class="el-icon-paperclip"></i>】</el-link></div>
					<el-table
						  class="ztran_table"
					      :data="info.record_list"
						  ref="multipleTable3"
						  tooltip-effect="dark"
						  @selection-change="handleSelectionChangeR"
					      style="width: 100%"
						  :row-key="row => row.id">
						  <el-table-column 
						        type="selection"
						        width="55">
						      </el-table-column>
							  
							
							  
						
					      <el-table-column prop="name" align="center" :label="$t('live.modelName')" >
								<template slot-scope="scope">
									{{scope.row.key}}{{scope.row.name}}
								</template>
							</el-table-column>
				 
						  <el-table-column  prop="date" align="center" label="HLS" >
						  	   <template slot-scope="scope">
						  			<span class="text-success" v-if="scope.row.data.hlsStatus==1">{{$t('cdnd.open')}}</span>
						  			<span class="text-danger" v-if="scope.row.data.hlsStatus==0">{{$t('cdnd.close')}}</span>
						  	   </template>
						  </el-table-column>
						  
						  <el-table-column  prop="date" align="center" label="FLV" >
						  	   <template slot-scope="scope">
						  			<span class="text-success" v-if="scope.row.data.flvStatus==1">{{$t('cdnd.open')}}</span>
						  			<span class="text-danger" v-if="scope.row.data.flvStatus==0">{{$t('cdnd.close')}}</span>
						  	   </template>
						  </el-table-column>
						  
						  <el-table-column  prop="date" align="center" label="MP4" >
						  	   <template slot-scope="scope">
						  			<span class="text-success" v-if="scope.row.data.mp4Status==1">{{$t('cdnd.open')}}</span>
						  			<span class="text-danger" v-if="scope.row.data.mp4Status==0">{{$t('cdnd.close')}}</span>
						  	   </template>
						  </el-table-column>
						   
						   <el-table-column   prop="remark" align="center" :label="$t('liveModel.remark')" >
							  
						   </el-table-column>
						   
						  
						 
						  
					
					    </el-table>
				
					
					
				
				</div>
				
				<div v-show="openType==9">
					<div class="mb-3" style="display: flex;align-items: center;">{{$t('live.tranTo')}} 
					<el-link @click="toModel" type="primary">【{{$t('router.model')}} <i class="el-icon-paperclip"></i>】</el-link></div>
					<el-table
					      :data="info.tran_list"
						  ref="multipleTable"
						  tooltip-effect="dark"
						  @selection-change="handleSelectionChange"
					      style="width: 100%"
						  :row-key="row => row.id">
						  <el-table-column
						        type="selection"
						        width="55">
						      </el-table-column>
					      <el-table-column prop="name" align="center" :label="$t('live.modelName')" >
								<template slot-scope="scope">
									{{scope.row.key}}{{scope.row.name}}
								</template>
							</el-table-column>
 
						   <el-table-column  prop="date" align="center" :label="$t('live.modelType')" >
							   <template slot-scope="scope">
									<span v-if="scope.row.video_type==1">{{$t('live.videoType1')}}</span>
									<span v-if="scope.row.video_type==2">{{$t('live.videoType2')}}</span>
							   </template>
						   </el-table-column>
						   <el-table-column  prop="date" align="center" :label="$t('live.ma_type')" >
							   <template slot-scope="scope">
									<span v-if="scope.row.code_type==264">H.264</span>
									<span v-if="scope.row.code_type==265">H.265</span>
							   </template>
						   </el-table-column>
						   <el-table-column   prop="date" align="center" :label="$t('live.videoBitrate')" >
							   <template slot-scope="scope">
									<span v-if="scope.row.ma_type==1">{{scope.row.ma_value}} kbps</span>
									<span v-if="scope.row.ma_type==2">{{$t('live.setMa2')}}</span>
							   </template>
						   </el-table-column>
						   <el-table-column width="300" prop="date" align="center" :label="$t('live.fenbianlv')"  >
							   <template slot-scope="scope">
								<span v-if="scope.row.wh_type==1">
								   <span>{{$t('live.height')}}：{{scope.row.wh_value}} px</span>&nbsp;
								   <span>{{$t('live.width')}}</span>
								</span>
								<span v-if="scope.row.wh_type==2">{{$t('live.setWH2')}}</span>
								
							   </template>
							
						   </el-table-column>
						  
					
					    </el-table>

					
					
				
				</div>
				
				
				
				<div v-show="openType==10">
					<div class="mb-3" style="display: flex;align-items: center;">{{$t('live.ztranTo')}} 
					<el-link @click="toModel" type="primary">【{{$t('router.model')}} <i class="el-icon-paperclip"></i>】</el-link></div>
					<el-table
						  class="ztran_table"
					      :data="info.ztran_list"
						  ref="multipleTable2"
						  tooltip-effect="dark"
						  @selection-change="handleSelectionChangeZ"
					      style="width: 100%"
						  :row-key="row => row.id">
						  <el-table-column 
						        type="selection"
						        width="55">
						      </el-table-column>
							  
							<el-table-column  type="expand" :label="$t('liveModel.zi')">
								<template slot-scope="props">
									<div style="padding-left: 55px;overflow-x: auto;">
										<el-table   stripe  :data="props.row.chil"  >
											
															
											<el-table-column width="120" align="center" prop="s_name" :label="$t('liveModel.name')">
											
											
											</el-table-column>
											
											
											
											
											
											<el-table-column   prop="date" align="center" :label="$t('live.modelType')" >
											   <template slot-scope="scope">
													<span v-if="scope.row.video_type==1">{{$t('live.videoType1')}}</span>
													<span v-if="scope.row.video_type==2">{{$t('live.videoType2')}}</span>
											   </template>
											</el-table-column>
											<el-table-column  prop="date" align="center" :label="$t('live.ma_type')" >
												   <template slot-scope="scope">
														<span v-if="scope.row.code_type==264">H.264</span>
														<span v-if="scope.row.code_type==265">H.265</span>
												   </template>
											</el-table-column>
											<el-table-column   prop="date" align="center" :label="$t('live.videoBitrate')" >
												   <template slot-scope="scope">
														<span v-if="scope.row.ma_type==1">{{scope.row.ma_value}} kbps</span>
														<span v-if="scope.row.ma_type==2">{{$t('live.setMa2')}}</span>
												   </template>
											</el-table-column>
											<el-table-column width="300" prop="date" align="center" :label="$t('live.fenbianlv')"  >
											   <template slot-scope="scope">
												   
												   <span v-if="scope.row.wh_type==1">
													   <span>{{$t('live.height')}}：{{scope.row.wh_value}} px</span>&nbsp;
													   <span>{{$t('live.width')}}</span>
												   </span>
												   <span v-if="scope.row.wh_type==2">{{$t('live.setWH2')}}</span>
												   
												   
												
												
											   </template>
																			
											</el-table-column>
											
											<el-table-column   prop="date" align="center" :label="$t('live.videoFrameRate')" >
												   <template slot-scope="scope">
														<span v-if="scope.row.z_type==1">{{scope.row.z_value}} fps</span>
														<span v-if="scope.row.z_type==2">{{$t('live.setZ2')}}</span>
												   </template>
											</el-table-column>
											
											<el-table-column   prop="date" align="center" label="GOP" >
												   <template slot-scope="scope">
														{{scope.row.gop}} s
												   </template>
											</el-table-column>
										</el-table>
									</div>
									
								</template>
							   </el-table-column>
							  
						
					      <el-table-column prop="name" align="center" :label="$t('live.modelName')" >
								<template slot-scope="scope">
									{{scope.row.key}}{{scope.row.name}}
								</template>
							</el-table-column>
				 
						  
						   
						   <el-table-column   prop="remark" align="center" :label="$t('liveModel.remark')" >
							  
						   </el-table-column>
						   
						   <el-table-column   prop="num" align="center" :label="$t('liveModel.num')" >
						   							  
						   </el-table-column>
						 
						  
					
					    </el-table>
				
					
					
				
				</div>
				
				
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">{{$t('adminList.cancel')}}</el-button>
				<el-button :loading="layout.loading" :disabled="layout.loading || (!form.url_auth && !form.agree && openType==2)" type="primary" @click="submit">{{$t('adminList.confirm')}}</el-button>
			</div>
		</el-dialog>
		
		<el-dialog :close-on-click-modal="false"
			:title="$t('live.apiTis')"
			:visible.sync="apiModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			
			 <template>
			   <div class="doc-page">
			     <el-card shadow="hover">
			       <h4>{{from.type==1?$t('live.apitis1'):$t('live.apitis1_1')}}</h4>
			       <p class="desc">{{from.type==1?$t('live.apitis2'):$t('live.apitis2_1')}}</p>
			 
			       <el-divider>{{$t('live.apitis3')}}</el-divider>
			       <el-card shadow="never" body-style="padding: 20px; background: #fdfdfd;">
			         <div style="font-size: 14px; line-height: 2;">
			       
			           <p>
			             <strong style="width: 100px; display: inline-block;">{{$t('live.apitis4')}}：</strong>
			             <span style="color: #409EFF; font-weight: bold;">{{info.api_url}}
						 <span class="iconCopy" @click="copyText(info.api_url)"><i class="iconfont icon-fuzhi"></i></span></span>
						
			           </p>
					   
					   <p v-if="info.api_url2">
					     <strong style="width: 100px; display: inline-block;">{{$t('live.apitis4_1')}}：</strong>
					     <span style="color: #409EFF; font-weight: bold;">{{info.api_url2}}
					   						 <span class="iconCopy" @click="copyText(info.api_url2)"><i class="iconfont icon-fuzhi"></i></span></span>
					   			<span class="ml-2">({{$t('live.apitis4_2')}})</span>
					   </p>
			       
			           <p>
			             <strong style="width: 100px; display: inline-block;">{{$t('live.apitis5')}}：</strong>
			             <span>POST</span>
			           </p>
			       
			           <p>
			             <strong style="width: 100px; display: inline-block;">{{$t('live.apitis6')}}：</strong>
			             <span>application/json 或 x-www-form-urlencoded</span>
			           </p>
			       
			           <p>
			             <strong style="width: 100px; display: inline-block;">{{$t('live.apitis7')}}：</strong>
			             <span>MD5</span>
			           </p>
			       
			           <p>
			             <strong style="width: 100px; display: inline-block; color: #F56C6C;">{{$t('live.apitis8')}}：</strong>
			             <span style="font-family: monospace; background: #f2f2f2; padding: 2px 6px; border-radius: 4px; color: #333;">
			               {{info.api_key}}
			               <span class="iconCopy" @click="copyText(info.api_key)"><i class="iconfont icon-fuzhi"></i></span>
						   
			             </span>
			           </p>
					   
					   
					   <p>
					     <strong style="width: 100px; display: inline-block; color: #F56C6C;">{{info.type==1?$t('live.type1'):$t('live.type2')}}：</strong>
					     <span style="font-family: monospace; background: #f2f2f2; padding: 2px 6px; border-radius: 4px; color: #333;">
					       {{info.domain}}
					       <span class="iconCopy" @click="copyText(info.domain)"><i class="iconfont icon-fuzhi"></i></span>
					   						   
					     </span>
					   </p>
					   			       
			       
			         </div>
			       </el-card>

			 
			       <el-divider>{{$t('live.apitis9')}}</el-divider>
			       <el-table :data="apiParamList" border style="width: 100%">
			         <el-table-column prop="name" :label="$t('live.apitis16')" width="150" />
			         <el-table-column prop="type" :label="$t('live.type')" width="100" />
			         <el-table-column prop="required" :label="$t('live.apitis17')" width="80" />
			         <el-table-column prop="desc" :label="$t('live.apitis18')" />
			       </el-table>
			 
			      <el-divider>{{$t('live.apitis19')}}</el-divider>
			      <el-card shadow="never" class="mb-3">
			        <div class="text-block">
			          <p>{{$t('live.apitis20')}} <code>sign</code>，{{$t('live.apitis21')}}。</p>
			      
			          
			          <p style="font-weight:bold;">{{$t('live.apitis22')}}：</p>
			          <ul>
			            <li>{{$t('live.apitis23')}} <code>key</code>（{{$t('live.apitis24')}}）</li>
			            <li><code>timestamp</code> {{$t('live.apitis25')}}</li>
			            <li><code>nonce</code> {{$t('live.apitis26')}}</li>
			            <li>{{$t('live.apitis27')}} <code>AppName</code>、<code>StreamName</code> {{$t('live.apitis28')}}</li>
			          </ul>
			      
			          <p style="font-weight:bold;">{{$t('live.apitis29')}}：</p>
			          <ol>
			            <li>{{$t('live.apitis30')}} <code>sign</code> {{$t('live.apitis31')}}</li>
			            <li>{{$t('live.apitis32')}} <strong>{{$t('live.apitis33')}}</strong> {{$t('live.apitis34')}}</li>
			            <li>{{$t('live.apitis35')}}：<br />
			              <code>signStr = key + timestamp + nonce + k1 + v1 + k2 + v2 + ...</code>
			            </li>
			            <li>{{$t('live.apitis36')}} <code>md5</code> {{$t('live.apitis37')}}</li>
			            <li>{{$t('live.apitis38')}} <code>sign</code> {{$t('live.apitis39')}}</li>
			          </ol>
			      
			          <el-descriptions :title="$t('live.apitis40')" :column="1" border>
			            <el-descriptions-item label="key">
						abc123456
						
						</el-descriptions-item>
			            <el-descriptions-item label="DomainName">tl.example.com</el-descriptions-item>
			            <el-descriptions-item label="AppName">live</el-descriptions-item>
			            <el-descriptions-item label="StreamName">test001</el-descriptions-item>
			            <el-descriptions-item label="AuthDelta">3600</el-descriptions-item>
			            <el-descriptions-item label="timestamp">1720000000</el-descriptions-item>
			            <el-descriptions-item label="nonce">abcxyz</el-descriptions-item>
			            <el-descriptions-item v-if="from.type==2" label="TemplateName">hd</el-descriptions-item>
						
			          </el-descriptions>
			      
			          <p style="font-weight:bold; margin-top: 10px;">1. {{$t('live.apitis41')}}：</p>
			          <el-card shadow="never">
			            AppName=live<br />
			            AuthDelta=3600<br />
			            DomainName=tl.example.com<br />
			            StreamName=test001<br />
			            nonce=abcxyz<br />
			            timestamp=1720000000
						<span v-if="from.type==2"><br />TemplateName=hd</span>
			          </el-card>
			      
			          <p style="font-weight:bold; margin-top: 10px;">2. {{$t('live.apitis42')}}：</p>
			          <el-card shadow="never">
			            abc1234561720000000abcxyzAppNameliveAuthDelta3600DomainNametl.example.comStreamNametest001<span v-if="from.type==2">TemplateNamehd</span>
			          </el-card>
			      
			          <p style="font-weight:bold; margin-top: 10px;">3. {{$t('live.apitis44')}} md5：</p>
			          <el-card shadow="never">
			            sign = md5({{$t('live.apitis44')}}) = <span style="color:#409EFF;">
							<span v-if="from.type==1">aab3fe4cb225ac77aa12a776fe2c4a51</span>
							<span v-if="from.type==2">835d4d1d5a575ce678c20c8b71b27a95</span>
							</span>
			          </el-card>
			      
			          
			        </div>
			      </el-card>
				  
				 
					<!-- 4. 请求示例 -->
					<el-divider>{{$t('live.apitis45')}}</el-divider>
					<el-card shadow="never" body-style="padding: 12px; background: #f9f9f9;">
					  <pre v-if="from.type==1" style="margin: 0; font-size: 13px; line-height: 1.8; color: #333; background: none; ">
	{
		"DomainName": "tl.example.com",
		"AppName": "live",
		"StreamName": "test001",
		"AuthDelta": 3600,
		"timestamp": 1720000000,
		"nonce": "abcxyz",
		"sign": "4a0c6a205dfedb3d47be0cfcfcae7a45",
	}
					  </pre>
					  <pre v-if="from.type==2" style="margin: 0; font-size: 13px; line-height: 1.8; color: #333; background: none; ">
	{
		"DomainName": "tl.example.com",
		"AppName": "live",
		"StreamName": "test001",
		"AuthDelta": 3600,
		"timestamp": 1720000000,
		"nonce": "abcxyz",
		"sign": "4a0c6a205dfedb3d47be0cfcfcae7a45",
		"TemplateName": "hd"
	}
					    </pre>
					</el-card>
					
					<!-- 5. 响应示例 -->
					<el-divider>{{$t('live.apitis46')}}</el-divider>
					<el-card shadow="never" body-style="padding: 12px; background: #f9f9f9;">
					  <pre v-if="from.type==1" style="margin: 0; font-size: 13px; line-height: 1.8; color: #333; background: none;">
	{
		"code": 200,
		"msg": "success",
		"data": {
			"push": {
				"domain":"tl.example.com",
				"rtmp": "rtmp://tl.example.com/live/test001?txSecret=xxx&txTime=xxx",
				"webrtc": "webrtc://tl.example.com/live/test001?txSecret=xxx&txTime=xxx",
				"obs_server": "rtmp://tl.example.com/live/",
				"obs_streamKey": "test001?txSecret=xxx&txTime=xxx",
				"ExpirationDate": "2025-07-05 10:32:47"
			},
			"playInfoResult": [
				{
					"domain": "play1.example.com",
					"pull": {
						"domain":"play1.example.com",
						"rtmp": "rtmp://play1.example.com/live/stream1?expire=xxx&sign=xxx",
						"webrtc": "http://play1.example.com/live/stream1.sdp?expire=xxx&sign=xxx",
						"flv_url": "http://play1.example.com/live/stream1.flv?expire=xxx&sign=xxx",
						"hls_url": "http://play1.example.com/live/stream1.m3u8?expire=xxx&sign=xxx",
						"ExpirationDate": "2025-09-23 18:28:13"
					},
					"AllTranscodingList": [
						{
							"type": "general",
							"TemplateName": "TemplateA",
							"rtmp": "rtmp://play1.example.com/live/stream1?expire=xxx&sign=xxx",
							"webrtc": "http://play1.example.com/live/stream1_TemplateA.sdp?expire=xxx&sign=xxx",
							"flv_url": "http://play1.example.com/live/stream1_TemplateA.flv?expire=xxx&sign=xxx",
							"hls_url": "http://play1.example.com/live/stream1_TemplateA.m3u8?expire=xxx&sign=xxx",
							"ExpirationDate": "2025-09-23 18:28:13"
						}
					]
				},
				{
					"domain": "play2.example.com"
					...
				},
			]
			
		},
		"requestId": "mfxskhoxac32bc31a794138f"
	}
					  </pre>
					  
					  <pre v-if="from.type==2" style="margin: 0; font-size: 13px; line-height: 1.8; color: #333; background: none;">
	{
		"code": 200,
		"msg": "success",
		"data": {
			"pull": {
				"domain": "play.example.com",
				"rtmp": "rtmp://play.example.com/live/test001?txSecret=xxx&txTime=xxx",
				"webrtc": "webrtc://play.example.com/live/test001?txSecret=xxx&txTime=xxx",
				"flv_url": "http://play.example.com/live/test001.flv?txSecret=xxx&txTime=xxx",
				"hls_url": "http://play.example.com/live/test001.m3u8?txSecret=xxx&txTime=xxx",
				"ExpirationDate": "2025-07-05 10:32:47"
			},
			"transcode": {
				"rtmp": "rtmp://play.example.com/live/test001_hd?txSecret=xxx&txTime=xxx",
				"webrtc": "webrtc://play.example.com/live/test001_hd?txSecret=xxx&txTime=xxx",
				"flv_url": "http://play.example.com/live/test001_hd.flv?txSecret=xxx&txTime=xxx",
				"hls_url": "http://play.example.com/live/test001_hd.m3u8?txSecret=xxx&txTime=xxx",
				"ExpirationDate": "2025-07-05 10:32:47"
			},
			"AllTranscodingList": [
				{
					"type": "general",
					"TemplateName": "hd",
					"rtmp": "rtmp://play.example.com/live/test001_hd?txSecret=xxx&txTime=xxx",
					"webrtc": "webrtc://play.example.com/live/test001_hd?txSecret=xxx&txTime=xxx",
					"flv_url": "http://play.example.com/live/test001_hd.flv?txSecret=xxx&txTime=xxx",
					"hls_url": "http://play.example.com/live/test001_hd.m3u8?txSecret=xxx&txTime=xxx",
					"ExpirationDate": "2025-09-01 19:22:50"
				}
			]
			
		},
		"requestId": "mfxskhoxac32bc31a794138f"
	}
					    </pre>
					</el-card>

				   
				   
			 
			 
			      <el-divider >{{$t('live.apitis47')}}</el-divider>
			      <el-card  v-if="from.type==1" shadow="never" class="mb-3">
			        <div style="font-weight: bold; margin-bottom: 10px;">{{$t('live.apitis48')}}</div>
			        <el-table :data="[
			          { name: 'domain', type: 'string', desc: $t('live.type1') },
			          { name: 'rtmp', type: 'string', desc: $t('live.apitis49') },
			          { name: 'webrtc', type: 'string', desc: $t('live.apitis50') },
			          { name: 'obs_server', type: 'string', desc: $t('live.apitis51') },
			          { name: 'obs_streamKey', type: 'string', desc: $t('live.apitis52')},
			          { name: 'ExpirationDate', type: 'string', desc: $t('live.apitis53') }
			        ]" border style="width: 100%">
			          <el-table-column prop="name" :label="$t('live.apitis54')" width="160" />
			          <el-table-column prop="type" :label="$t('live.type')" width="120" />
			          <el-table-column prop="desc" :label="$t('live.apitis18')" />
			        </el-table>
			      </el-card>
				  
				  <el-card  v-if="from.type==2" shadow="never">
				    <div style="font-weight: bold; margin-bottom: 10px;">{{$t('live.apitis55')}}</div>
				    <el-table :data="[
					  { name: 'domain', type: 'string', desc: $t('live.type2') },
				      { name: 'rtmp', type: 'string', desc: $t('live.apitis56') },
				      { name: 'webrtc', type: 'string', desc: $t('live.apitis57') },
				      { name: 'flv_url', type: 'string', desc: $t('live.apitis58') },
				      { name: 'hls_url', type: 'string', desc: $t('live.apitis59') },
				      { name: 'ExpirationDate', type: 'string', desc: $t('live.apitis53') }
				    ]" border style="width: 100%">
				      <el-table-column prop="name" :label="$t('live.apitis54')" width="160" />
				      <el-table-column prop="type" :label="$t('live.type')" width="120" />
				      <el-table-column prop="desc" :label="$t('live.apitis18')" />
				    </el-table>
				  </el-card>
				  
				  <el-card  v-if="from.type==2" shadow="never" class="mt-3">
				    <div style="font-weight: bold; margin-bottom: 10px;">{{$t('live.apitis55_1')}}</div>
				    <el-table :data="[
					  { name: 'domain', type: 'string', desc: $t('live.type2') },
				      { name: 'rtmp', type: 'string', desc: $t('live.apitis56') },
				      { name: 'webrtc', type: 'string', desc: $t('live.apitis57') },
				      { name: 'flv_url', type: 'string', desc: $t('live.apitis58') },
				      { name: 'hls_url', type: 'string', desc: $t('live.apitis59') },
				      { name: 'ExpirationDate', type: 'string', desc: $t('live.apitis53') }
				    ]" border style="width: 100%">
				      <el-table-column prop="name" :label="$t('live.apitis54')" width="160" />
				      <el-table-column prop="type" :label="$t('live.type')" width="120" />
				      <el-table-column prop="desc" :label="$t('live.apitis18')" />
				    </el-table>
					
					<!-- 说明文字 -->
					<div style="margin-top: 6px; color: #606266; font-size: 14px; line-height: 20px;">
					  <p style="margin-top: 10px;">
					    <strong>{{$t('live.apitis72')}} <code>TemplateName</code> {{$t('live.apitis73')}}</strong>。
					  </p>
					  <p style="margin-top: 10p;">
					    {{$t('live.apitis74')}}<strong>{{$t('live.apitis75')}}</strong>（{{$t('live.apitis76')}}：<code>test001_hd</code>）。
					    {{$t('live.apitis77')}} <code>TemplateName</code> {{$t('live.apitis78')}}。
					  </p>
					  <p><strong>{{$t('live.apitis79')}}</strong>，{{$t('live.apitis80')}} <code>HLS</code> {{$t('live.apitis81')}}（<code>.m3u8</code>），{{$t('live.apitis82')}}。</p>
					</div>
				  </el-card>
				  
				  
				  <el-card  v-if="from.type==2" shadow="never" class="mt-3">
				    <div style="font-weight: bold; margin-bottom: 10px;">{{$t('live.apitis55_2')}}</div>
				    <el-table :data="[
				      { name: 'type', type: 'string', desc: $t('live.apitis83') },
				      { name: 'TemplateName', type: 'string', desc: $t('live.apitis84') },
				      { name: 'rtmp', type: 'string', desc: $t('live.apitis56') },
				      { name: 'webrtc', type: 'string', desc: $t('live.apitis57') },
				      { name: 'flv_url', type: 'string', desc: $t('live.apitis58') },
				      { name: 'hls_url', type: 'string', desc: $t('live.apitis59') },
				      { name: 'ExpirationDate', type: 'string', desc: $t('live.apitis53') }
				    ]" border style="width: 100%">
				      <el-table-column prop="name" :label="$t('live.apitis54')" width="160" />
				      <el-table-column prop="type" :label="$t('live.type')" width="120" />
				      <el-table-column prop="desc" :label="$t('live.apitis18')" />
				    </el-table>
				  					
						<!-- 说明文字 -->
						<div style="margin-top: 6px; color: #606266; font-size: 14px; line-height: 20px;">
						  <p style="margin-top: 10px;">
							<strong>{{$t('live.apitis72')}} <code>AllTranscodingList == 1</code> {{$t('live.apitis73')}}</strong>。
						  </p>
						  
						
						</div>
				  </el-card>
				  
				  
				  
				  
				  <el-card  v-if="from.type==1" shadow="never" class="mt-3">
				    <div style="font-weight: bold; margin-bottom: 10px;">{{$t('live.apitis55_3')}}</div>
				    <!-- 标题：playInfoResult（数组项）字段说明 -->
				    
				    <el-table
				      :data="[
				        { name: 'domain', type: 'string', desc: this.$t('live.apitis55_4') },
				        { name: 'pull', type: 'object', desc: this.$t('live.apitis55_5') },
				        { name: 'AllTranscodingList', type: 'array<object>', desc: this.$t('live.apitis55_6') }
				      ]"
				      border
				      style="width: 100%"
				    >
				      <el-table-column prop="name" :label="$t('live.apitis54')" width="160" />
				      <el-table-column prop="type" :label="$t('live.type')" width="160" />
				      <el-table-column prop="desc" :label="$t('live.apitis18')" />
				    </el-table>
				    
				    <!-- 标题：pull 字段说明 -->
				    <h4 class="table-title" id="pull-fields">{{$t('live.apitis55')}}</h4>
				    <el-table
				      :data="[
						{ name: 'domain', type: 'string', desc: $t('live.type2') },
				        { name: 'rtmp', type: 'string', desc: $t('live.apitis56') },
				        { name: 'webrtc', type: 'string', desc: $t('live.apitis57') },
				        { name: 'flv_url', type: 'string', desc: $t('live.apitis58') },
				        { name: 'hls_url', type: 'string', desc: $t('live.apitis59') },
				        { name: 'ExpirationDate', type: 'string', desc: $t('live.apitis53') }
				      ]"
				      border
				      style="width: 100%"
				    >
				      <el-table-column prop="name" :label="$t('live.apitis54')" width="160" />
				      <el-table-column prop="type" :label="$t('live.type')" width="160" />
				      <el-table-column prop="desc" :label="$t('live.apitis18')" />
				    </el-table>
				    
				    <!-- 标题：AllTranscodingList（单项）字段说明 -->
				    <h4 class="table-title" id="allTranscodingList-fields">{{$t('live.apitis55_7')}}</h4>
				    <el-table
				      :data="[
				        { name: 'type', type: 'string', desc: $t('live.apitis83') },   // e.g. general / adaptive
				        { name: 'TemplateName', type: 'string', desc: $t('live.apitis84') },
				        { name: 'rtmp', type: 'string', desc: $t('live.apitis56') },
				        { name: 'webrtc', type: 'string', desc: $t('live.apitis57') },
				        { name: 'flv_url', type: 'string', desc: $t('live.apitis58') },
				        { name: 'hls_url', type: 'string', desc: $t('live.apitis59') },
				        { name: 'ExpirationDate', type: 'string', desc: $t('live.apitis53') }
				      ]"
				      border
				      style="width: 100%"
				    >
				      <el-table-column prop="name" :label="$t('live.apitis54')" width="160" />
				      <el-table-column prop="type" :label="$t('live.type')" width="160" />
				      <el-table-column prop="desc" :label="$t('live.apitis18')" />
				    </el-table>

				  					
						<!-- 说明文字 -->
						<div style="margin-top: 6px; color: #606266; font-size: 14px; line-height: 20px;">
						  <p style="margin-top: 10px;">
							<strong>{{$t('live.apitis72')}} <code>playInfo == 1</code> {{$t('live.apitis73')}}</strong>。
						  </p>
						  
						
						</div>
				  </el-card>
				  
			 
			       <el-divider >{{$t('live.apitis60')}}</el-divider>
			       <el-card shadow="never">
			         <el-table :data="[
			           { code: 200, message: 'success', desc: $t('live.apitis61') },
			           { code: 400, message: $t('live.apitis68'), desc: $t('live.apitis62') },
			           { code: 401, message: $t('live.apitis69'), desc: $t('live.apitis63') },
			           { code: 405, message: $t('live.apitis70'), desc: $t('live.apitis64') },
			           { code: 500, message: $t('live.apitis71'), desc: $t('live.apitis65') }
			         ]" border style="width: 100%">
			           <el-table-column prop="code" :label="$t('live.apitis66')" width="100" />
			           <el-table-column prop="message" :label="$t('live.apitis67')" width="220" />
			           <el-table-column prop="desc" :label="$t('live.apitis18')" />
			         </el-table>
			       </el-card>
			       
			     </el-card>
			   </div>
			 </template>


			<div slot="footer" class="dialog-footer">
				<el-button @click="apiModel = false">{{$t('safe.close')}}</el-button>
				
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				apiModel:false,
				activeName:"1",
				createModel: false,
				editIndex: -1,
				info:{
					api_url:'',
					api_url2:''
				},
				rangeStatus:0,
				ssl_status:0,
				showAllIp:false,
				urlData:{
					app_name:'',
					stream_name:'',
					time:0,
					load:false,
					type:1,
					model_name:''
				},
				returnType:'1',
				urlShow:{
					status:0
				},
				watermarkPreview: {
					dragging: false,
					resizing: false,
					resizeCorner: '',
					dragOffsetX: 0,
					dragOffsetY: 0,
					dragMoveHandler: null,
					dragUpHandler: null,
					resizeStartX: 0,
					resizeStartY: 0,
					resizeStartScale: 100,
					resizeStartWidth: 0,
					resizeStartHeight: 0,
					resizeMoveHandler: null,
					resizeUpHandler: null,
					naturalWidth: 0,
					naturalHeight: 0
				},
				//搜索數据
				from: {
					id:0,
					name: '',
					username:'',
					sup_id:-1,
					status:-1,
					get_status:-1,
					type:-1,
					cloud_id:-1,
					time:[],
				},
				openType:1,
				auth_val: 'Admin',
				odds:0,
				preUrl: "data/liveDomainDetail", //列表地址
				delAllUrl: "data/delAccountAll", //批量删除地址
				delUrl: "data/delLivedomainTran", //删除單条地址
				addUrl: "data/addLivedomain", //添加/修改地址
				editStatusUrl:"data/editStatusLivedomain",//修改狀態地址
				agentData:[],
				tableData: [],
				form: {},
				rules: {
					url: [{
						required: true,
						message: this.$t('cdn.inpSource'),
						trigger: 'blur'
					}],
					cloud_id: [{
						required: true,
						message: this.$t('accountList.selCloud'),
						trigger: 'blur',
					}],
					back_url: [{
						required: true,
						message: this.$t('live.inpReturn'),
						trigger: 'blur',
					}],
					back_key: [{
						required: true,
						message: this.$t('live.inpReturnKey'),
						trigger: 'blur',
					}],
					ip_data: [{
						required: true,
						message: this.$t('live.inpipData'),
						trigger: 'blur',
					}],
					ref_data: [{
						required: true,
						message: this.$t('live.inpRefererRule'),
						trigger: 'blur',
					}],
					fileRef_data: [{
						required: true,
						message: this.$t('live.inpRefererRule'),
						trigger: 'blur',
					}],
					
					streamStartUrl: [{
						required: true,
						message: this.$t('live.inpReturn'),
						trigger: 'blur',
					}],
					streamEndUrl: [{
						required: true,
						message: this.$t('live.inpReturn'),
						trigger: 'blur',
					}],
					imgUrl: [{
						required: true,
						message: this.$t('live.inpReturn'),
						trigger: 'blur',
					}],
					recordFileUrl: [{
						required: true,
						message: this.$t('live.inpReturn'),
						trigger: 'blur',
					}],
					recordStatusUrl: [{
						required: true,
						message: this.$t('live.inpReturn'),
						trigger: 'blur',
					}],
					img_time: [{
						required: true,
						message: this.$t('live.inpimgTime'),
						trigger: 'blur',
					}],
					sel: [{
						required: true,
						message: this.$t('live.selrecordType'),
						trigger: 'blur',
					}],
					hlsMinute: [{
						required: true,
						message: this.$t('live.inprecordMinute'),
						trigger: 'blur',
					}],
					flvMinute: [{
						required: true,
						message: this.$t('live.inprecordMinute'),
						trigger: 'blur',
					}],
					mp4Minute: [{
						required: true,
						message: this.$t('live.inprecordMinute'),
						trigger: 'blur',
					}],
					hlsSecond: [{
						required: true,
						message: this.$t('live.inprecordSecond'),
						trigger: 'blur',
					}],
					ma_value: [{
						required: true,
						message: this.$t('live.inpvideoBitrate'),
						trigger: 'blur',
					}],
					resolution: [{
						required: true,
						message: this.$t('live.inpvideoResolution'),
						trigger: 'blur',
					}],
					z_value: [{
						required: true,
						message: this.$t('live.noNull'),
						trigger: 'blur',
					}],
					gop: [{
						required: true,
						message: this.$t('live.noNull'),
						trigger: 'blur',
					}],
					name: [{
						required: true,
						message: this.$t('live.noNull'),
						trigger: 'blur',
					}],
				},
				rule_list: [],
				check_img_list:[]
			}
		},
		watch: {
			refreshTrigger(newVal) {
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
			'form.sy_scale': function() {
				this.syncWatermarkWidthScale();
			},
			'form.preview_width': function() {
				this.syncWatermarkWidthScale();
			},
			'form.preview_height': function() {
				this.syncWatermarkWidthScale();
			},
			'form.sy_w': function() {
				this.syncWatermarkWidthScale();
			},
			'form.sy_h': function() {
				this.syncWatermarkWidthScale();
			},
		},
		computed: {
			
			// 监听 Vuex state
			...mapState(['refreshTrigger']), // 监听 Vuex state
			dialogTitle() {
			  const map = {
			    1: this.$t('cdnd.edit'),
			    2: this.$t('live.domainKey'),
			    3: this.$t('live.returnSet'),
			    4: this.$t('live.ipLog'),
			    5: this.$t('live.Referer'),
			    6: this.$t('live.httpSet'),
			    7: this.$t('live.imgSet'),
			    8: this.$t('live.recordSet'),
			    9: this.$t('live.transferSel'),
			    10: this.$t('live.zTranSet'),
			    11: this.$t('live.Referer2'),
			    12: this.$t('live.Referer3'),
			    13: this.$t('live.liveSy'),
			  };
			  return map[this.openType] || this.$t('live.httpSet');
			},
			watermarkPreviewPreset() {
				const previewWidth = Math.max(Number(this.form.preview_width) || 1920, 1);
				const previewHeight = Math.max(Number(this.form.preview_height) || 1080, 1);
				const maxWidth = 432;
				const maxHeight = 384;
				const ratio = Math.min(maxWidth / previewWidth, maxHeight / previewHeight, 1);
				return {
					width: Math.max(Math.round(previewWidth * ratio), 1),
					height: Math.max(Math.round(previewHeight * ratio), 1)
				};
			},
			watermarkPreviewStageStyle() {
				return {
					width: `${this.watermarkPreviewPreset.width}px`,
					height: `${this.watermarkPreviewPreset.height}px`
				};
			},
			watermarkPreviewBaseResolution() {
				return {
					width: Math.max(Number(this.form.preview_width) || 1920, 1),
					height: Math.max(Number(this.form.preview_height) || 1080, 1)
				};
			},
			watermarkResizeCorners() {
				return [
					{ key: 'top-left' },
					{ key: 'top-right' },
					{ key: 'bottom-left' },
					{ key: 'bottom-right' }
				];
			},
			watermarkPreviewImageStyle() {
				const stageWidth = this.watermarkPreviewPreset.width;
				const stageHeight = this.watermarkPreviewPreset.height;
				const naturalWidth = this.watermarkPreview.naturalWidth || 1;
				const naturalHeight = this.watermarkPreview.naturalHeight || 1;
				const baseResolution = this.watermarkPreviewBaseResolution;
				const scale = this.normalizeWatermarkValue(this.form.sy_scale, 100, 1, 100);
				let previewWidth = (naturalWidth / baseResolution.width) * stageWidth * (scale / 100);
				let previewHeight = (naturalHeight / baseResolution.height) * stageHeight * (scale / 100);

				previewWidth = Math.max(previewWidth, 8);
				previewHeight = Math.max(previewHeight, 8);

				if (previewWidth > stageWidth) {
					const ratio = stageWidth / previewWidth;
					previewWidth = stageWidth;
					previewHeight = previewHeight * ratio;
				}

				if (previewHeight > stageHeight) {
					const ratio = stageHeight / previewHeight;
					previewHeight = stageHeight;
					previewWidth = previewWidth * ratio;
				}

				const x = this.normalizeWatermarkValue(this.form.sy_x, 0, 0, 100);
				const y = this.normalizeWatermarkValue(this.form.sy_y, 0, 0, 100);
				const left = ((stageWidth - previewWidth) * x) / 100;
				const top = ((stageHeight - previewHeight) * y) / 100;

				return {
					width: `${previewWidth}px`,
					height: `${previewHeight}px`,
					transform: `translate(${left}px, ${top}px)`
				};
			},
			watermarkPreviewMetrics() {
				const stageWidth = this.watermarkPreviewPreset.width;
				const stageHeight = this.watermarkPreviewPreset.height;
				const naturalWidth = this.watermarkPreview.naturalWidth || 1;
				const naturalHeight = this.watermarkPreview.naturalHeight || 1;
				const baseResolution = this.watermarkPreviewBaseResolution;
				const scale = this.normalizeWatermarkValue(this.form.sy_scale, 100, 1, 100);
				let previewWidth = (naturalWidth / baseResolution.width) * stageWidth * (scale / 100);
				let previewHeight = (naturalHeight / baseResolution.height) * stageHeight * (scale / 100);

				previewWidth = Math.max(previewWidth, 8);
				previewHeight = Math.max(previewHeight, 8);

				if (previewWidth > stageWidth) {
					const ratio = stageWidth / previewWidth;
					previewWidth = stageWidth;
					previewHeight = previewHeight * ratio;
				}

				if (previewHeight > stageHeight) {
					const ratio = stageHeight / previewHeight;
					previewHeight = stageHeight;
					previewWidth = previewWidth * ratio;
				}

				return {
					stageWidth,
					stageHeight,
					previewWidth,
					previewHeight
				};
			},
			apiParamList() {
			    const list = [
			      { name: 'DomainName', type: 'string', required: this.$t('live.yes'), desc: this.info.type==1?this.$t('live.type1') :this.$t('live.type2') + ' ' +this.$t('live.apitisClientTis')},
			      { name: 'AppName', type: 'string', required: this.$t('live.yes'), desc: this.$t('live.apitis10') },
			      { name: 'StreamName', type: 'string', required: this.$t('live.yes'), desc: this.$t('live.apitis11') },
			      { name: 'AuthDelta', type: 'int', required: this.$t('live.yes'), desc: this.$t('live.apitis12') },
			      { name: 'timestamp', type: 'int', required: this.$t('live.yes'), desc: this.$t('live.apitis13') },
			      { name: 'nonce', type: 'string', required: this.$t('live.yes'), desc: this.$t('live.apitis14') },
			      { name: 'sign', type: 'string', required: this.$t('live.yes'), desc: this.$t('live.apitis15') },
				  { name: 'client', type: 'string', required: this.$t('live.no'), desc: this.$t('live.apitisClient') },
				  { name: 'DomainType', type: 'int', required: this.$t('live.no'), desc: this.$t('live.apitisClientType') },
			      { name: 'TemplateName', type: 'string', required: this.$t('live.no'), desc: this.$t('live.apitis15_1'), onlyForPlay: true },
				  { name: 'AllTranscoding', type: 'int', required: this.$t('live.no'), desc: this.$t('live.apitis15_2'), onlyForPlay: true },
				  
				  // 推流专属
					{ name: 'playInfo', type: 'int', required: this.$t('live.no'), desc: this.$t('live.apitis15_3'), onlyForPush: true },
			    ];
			
			    // 如果是推流（type=1），过滤掉仅限播放用的字段
			    return list.filter(item => {
			        if (this.from.type === 1) {
			          // 推流
			          return !item.onlyForPlay;
			        } else {
			          // 播放
			          return !item.onlyForPush;
			        }
			      });
			  }
		},
		created() {
			this.commonList('liveDomain');
			
			if(localStorage.getItem('commonDetailPage')){
				let commonDetailPage = JSON.parse(localStorage.getItem('commonDetailPage'));
				//this.from.name = commonDetailPage.domain_name
				this.from.id = commonDetailPage.id
				console.log(commonDetailPage)
			}else{
				this.goBack()
			}
		},
		beforeDestroy() {
			this.stopWatermarkDrag();
			this.stopWatermarkResize();
		},

		methods: {
			getColor(endTime) {
			    const now = new Date();
			    const end = new Date(endTime);
			    const diff = end - now;
			
			    if (diff < 0) return 'red';               // 已過期
			    if (diff < 7 * 24 * 60 * 60 * 1000) return 'orange'; // 7天內過期
			    return 'black';                           // 正常
			  },
			  
			  shouldShowButton(endTime) {
			    const now = new Date();
			    const end = new Date(endTime);
			    const diff = end - now;
				const ONE_WEEK = 7 * 24 * 60 * 60 * 1000;
				
				  // 只要不是 “距离到期 > 7 天”，就显示按钮
				return diff <= ONE_WEEK;
			  },
			
			  
			  reloadData(type='tran') {
				  if(type=='ztran'){
					  this.$nextTick(() => {
					      const table = this.$refs.multipleTable2
					      if (table) table.clearSelection()
					    })
					// 同步选中的 id 到 this.form.selIds
					  this.form.selIds = this.info.ztran_list
					    .filter(row => row.is_sel === 1)
					    .map(row => row.id);
					
					  this.$nextTick(() => {
					    this.info.ztran_list.forEach(row => {
					      if (row.is_sel === 1) {
					        this.$refs.multipleTable2.toggleRowSelection(row, true);
					      }
					    });
					  });
					  
					  
				  }else if(type=='record'){
					  this.$nextTick(() => {
					      const table = this.$refs.multipleTable3
					      if (table) table.clearSelection()
					    })
					// 同步选中的 id 到 this.form.selIds
					  this.form.selIds = this.info.record_list
					    .filter(row => row.is_sel === 1)
					    .map(row => row.id);
					
					  this.$nextTick(() => {
					    this.info.record_list.forEach(row => {
					      if (row.is_sel === 1) {
					        this.$refs.multipleTable3.toggleRowSelection(row, true);
					      }
					    });
					  });
					  
					  
				  }else{
					  this.$nextTick(() => {
					      const table = this.$refs.multipleTable
					      if (table) table.clearSelection()
					    })
					// 同步选中的 id 到 this.form.selIds
					  this.form.selIds = this.info.tran_list
					    .filter(row => row.is_sel === 1)
					    .map(row => row.id);
					
					  this.$nextTick(() => {
					    this.info.tran_list.forEach(row => {
					      if (row.is_sel === 1) {
					        this.$refs.multipleTable.toggleRowSelection(row, true);
					      }
					    });
					  });
					  console.log( this.form.selIds)
				  }
			     
			      
			  	  
			    },
			  changeUrlType(e){
				this.urlShow.status  = 0
				this.urlData.model_name = ''
			  },
			 handleSelectionChange(val) {
			  this.form.selIds = val.map(row => row.id);
			},

			 handleSelectionChangeZ(val) {
				const table = this.$refs.multipleTable2;
				
				    if (val.length > 1) {
				      // 保留最后一项，清空其它
				      const last = val[val.length - 1];
				      table.clearSelection();
				      table.toggleRowSelection(last, true);
				      this.form.selIds = [last.id];
				    } else {
				      // 只有 0 或 1 个，直接更新
				      this.form.selIds = val.map(row => row.id);
				    }
			},
			 handleSelectionChangeR(val) {
				const table = this.$refs.multipleTable3;
				
				    if (val.length > 1) {
				      // 保留最后一项，清空其它
				      const last = val[val.length - 1];
				      table.clearSelection();
				      table.toggleRowSelection(last, true);
				      this.form.selIds = [last.id];
				    } else {
				      // 只有 0 或 1 个，直接更新
				      this.form.selIds = val.map(row => row.id);
				    }
			},
			toModel(){
				localStorage.setItem('commonDetailPage', '');
				//跳转到指定页面
				let todata = {type:'toType',value:''}
				if(this.openType==10){
					todata.value = 'ztran'
				}else if(this.openType==8){
					todata.value = 'record'
				}else{
					todata.value = 'tran'
				}
				this.$router.push({
					name: 'live_model',
					params:todata
				})
			},
			selVideoP(e){
				console.log(e)
				this.form.ma_type=1
				if(e==360){
					this.form.ma_value=400
					this.form.resolution=360
				}
				if(e==540){
					this.form.ma_value=720
					this.form.resolution=540
				}
				if(e==720){
					this.form.ma_value=1000
					this.form.resolution=720
				}
				if(e==1080){
					this.form.ma_value=2000
					this.form.resolution=1080
				}
				if(e==1440){
					this.form.ma_value=3000
					this.form.resolution=1440
				}
			},
			limitRange(field, min = 15, max = 360) {
				let val = this.form[field]
			    const num = Number(val);
			    if (isNaN(num)) return;
			
			    if (num < min) this.form[field] = min;
			    else if (num > max) this.form[field] = max;
			    else this.form[field] = num;
			  },
			handleIpInput(val) {
				let num = 100
				console.log(num)
			    const lines = val.split('\n');
			    if (lines.length > num) {
			      this.form.ip_data = lines.slice(0, num).join('\n'); // 只保留前 50 行
			      this.$message.warning(this.$t('live.limitSource'));
			    }
			  },
			
			goBack(){
				let commonDetailPage = JSON.parse(localStorage.getItem('commonDetailPage'));
				localStorage.setItem('commonDetailPage', '');
				this.$router.push({
					name: commonDetailPage.page,
					params:{}
				})
			},
			checkKeyInp(val){
				
				const clean = val.replace(/[^a-zA-Z0-9]/g, '').slice(0, 32);
				this.form.zKey = clean;
			},
			checkKeyInp2(val){
				const clean = val.replace(/[^a-zA-Z0-9]/g, '').slice(0, 32);
				this.form.fKey = clean;
			},
			checkKeyInp3(val){
				const clean = val.replace(/[^a-zA-Z0-9]/g, '').slice(0, 32);
				this.form.back_key = clear;
			},
			normalizeWatermarkValue(value, fallback = 0, min = 0, max = 100) {
				const numberValue = Number(value);
				if (Number.isNaN(numberValue)) {
					return fallback;
				}
				return Math.min(Math.max(numberValue, min), max);
			},
			formatWatermarkPercent(value) {
				return `${this.normalizeWatermarkValue(value).toFixed(2)}%`;
			},
			calculateWatermarkWidthScale(scale = this.form.sy_scale, imageWidth = this.form.sy_w, previewWidth = this.form.preview_width, imageHeight = this.form.sy_h, previewHeight = this.form.preview_height) {
				const safePreviewWidth = Math.max(Number(previewWidth) || 0, 0);
				const safePreviewHeight = Math.max(Number(previewHeight) || 0, 0);
				const safeImageWidth = Math.max(Number(imageWidth) || 0, 0);
				const safeImageHeight = Math.max(Number(imageHeight) || 0, 0);
				const safeScale = this.normalizeWatermarkValue(scale, 100, 1, 100);
				if (!safePreviewWidth || !safePreviewHeight || !safeImageWidth || !safeImageHeight) {
					return 0;
				}
				let widthPercent = (safeImageWidth / safePreviewWidth) * safeScale;
				let heightPercent = (safeImageHeight / safePreviewHeight) * safeScale;

				if (widthPercent > 100) {
					const ratio = 100 / widthPercent;
					widthPercent = 100;
					heightPercent = heightPercent * ratio;
				}

				if (heightPercent > 100) {
					const ratio = 100 / heightPercent;
					heightPercent = 100;
					widthPercent = widthPercent * ratio;
				}

				return Number(widthPercent.toFixed(2));
			},
			syncWatermarkWidthScale() {
				if (!this.form || this.openType !== 13) return;
				this.form.sy_scale_w = this.calculateWatermarkWidthScale();
			},
			hasWatermarkTranscodeConfig() {
				const hasSelectedRows = (list) => Array.isArray(list) && list.length > 0;
				const hasMarkedRows = (list) => Array.isArray(list) && list.some(item => Number(item.is_sel) === 1);
				return hasSelectedRows(this.info.sel_tran_list)
					|| hasSelectedRows(this.info.sel_ztran_list)
					|| hasMarkedRows(this.info.tran_list)
					|| hasMarkedRows(this.info.ztran_list);
			},
			handleWatermarkStatusChange(value) {
				if (!value) return;
				if (this.hasWatermarkTranscodeConfig()) return;
				this.$nextTick(() => {
					this.form.sy_status = false;
				});
				this.$message.warning(this.$t('live.liveSyConfigWarning'));
			},
			handleWatermarkPreviewLoad(event) {
				const target = event && event.target;
				if (!target) return;
				this.watermarkPreview.naturalWidth = target.naturalWidth || 0;
				this.watermarkPreview.naturalHeight = target.naturalHeight || 0;
				this.form.sy_w = target.naturalWidth || 0;
				this.form.sy_h = target.naturalHeight || 0;
				this.syncWatermarkWidthScale();
			},
			startWatermarkDrag(event) {
				if (!this.form.sy) return;
				if (event.button !== 0) return;
				if (this.watermarkPreview.resizing) return;
				const imageRect = event.target.getBoundingClientRect();
				const { previewWidth, previewHeight } = this.watermarkPreviewMetrics;
				if (!previewWidth || !previewHeight) return;

				this.watermarkPreview.dragging = true;
				this.watermarkPreview.dragOffsetX = event.clientX - imageRect.left;
				this.watermarkPreview.dragOffsetY = event.clientY - imageRect.top;
				document.body.style.userSelect = 'none';

				if (!this.watermarkPreview.dragMoveHandler) {
					this.watermarkPreview.dragMoveHandler = (moveEvent) => this.handleWatermarkDrag(moveEvent);
				}
				if (!this.watermarkPreview.dragUpHandler) {
					this.watermarkPreview.dragUpHandler = () => this.stopWatermarkDrag();
				}

				window.addEventListener('mousemove', this.watermarkPreview.dragMoveHandler);
				window.addEventListener('mouseup', this.watermarkPreview.dragUpHandler);
			},
			startWatermarkResize(event, corner) {
				if (!this.form.sy) return;
				if (event.button !== 0) return;
				this.stopWatermarkDrag();
				this.watermarkPreview.resizing = true;
				this.watermarkPreview.resizeCorner = corner;
				this.watermarkPreview.resizeStartX = event.clientX;
				this.watermarkPreview.resizeStartY = event.clientY;
				this.watermarkPreview.resizeStartScale = this.normalizeWatermarkValue(this.form.sy_scale, 100, 1, 100);
				this.watermarkPreview.resizeStartWidth = this.watermarkPreviewMetrics.previewWidth;
				this.watermarkPreview.resizeStartHeight = this.watermarkPreviewMetrics.previewHeight;
				document.body.style.userSelect = 'none';

				if (!this.watermarkPreview.resizeMoveHandler) {
					this.watermarkPreview.resizeMoveHandler = (moveEvent) => this.handleWatermarkResize(moveEvent);
				}
				if (!this.watermarkPreview.resizeUpHandler) {
					this.watermarkPreview.resizeUpHandler = () => this.stopWatermarkResize();
				}

				window.addEventListener('mousemove', this.watermarkPreview.resizeMoveHandler);
				window.addEventListener('mouseup', this.watermarkPreview.resizeUpHandler);
			},
			handleWatermarkDrag(event) {
				if (!this.watermarkPreview.dragging) return;
				const screen = this.$refs.watermarkPreviewScreen;
				if (!screen) return;

				const rect = screen.getBoundingClientRect();
				const { previewWidth, previewHeight } = this.watermarkPreviewMetrics;
				const maxLeft = Math.max(rect.width - previewWidth, 0);
				const maxTop = Math.max(rect.height - previewHeight, 0);
				const nextLeft = Math.min(Math.max(event.clientX - rect.left - this.watermarkPreview.dragOffsetX, 0), maxLeft);
				const nextTop = Math.min(Math.max(event.clientY - rect.top - this.watermarkPreview.dragOffsetY, 0), maxTop);

				this.form.sy_x = maxLeft === 0 ? 0 : Number(((nextLeft / maxLeft) * 100).toFixed(2));
				this.form.sy_y = maxTop === 0 ? 0 : Number(((nextTop / maxTop) * 100).toFixed(2));
			},
			handleWatermarkResize(event) {
				if (!this.watermarkPreview.resizing) return;
				const deltaX = event.clientX - this.watermarkPreview.resizeStartX;
				const deltaY = event.clientY - this.watermarkPreview.resizeStartY;

				let delta = 0;
				if (this.watermarkPreview.resizeCorner === 'top-left') {
					delta = -deltaX - deltaY;
				} else if (this.watermarkPreview.resizeCorner === 'top-right') {
					delta = deltaX - deltaY;
				} else if (this.watermarkPreview.resizeCorner === 'bottom-left') {
					delta = -deltaX + deltaY;
				} else {
					delta = deltaX + deltaY;
				}

				const baseSize = Math.max(this.watermarkPreview.resizeStartWidth, this.watermarkPreview.resizeStartHeight, 1);
				const nextScale = this.watermarkPreview.resizeStartScale + (delta / baseSize) * 100;
				this.form.sy_scale = Math.round(this.normalizeWatermarkValue(nextScale, 100, 1, 100));
			},
			stopWatermarkDrag() {
				this.watermarkPreview.dragging = false;
				if (this.watermarkPreview.dragMoveHandler) {
					window.removeEventListener('mousemove', this.watermarkPreview.dragMoveHandler);
				}
				if (this.watermarkPreview.dragUpHandler) {
					window.removeEventListener('mouseup', this.watermarkPreview.dragUpHandler);
				}
				if (!this.watermarkPreview.resizing) {
					document.body.style.userSelect = '';
				}
			},
			stopWatermarkResize() {
				this.watermarkPreview.resizing = false;
				this.watermarkPreview.resizeCorner = '';
				if (this.watermarkPreview.resizeMoveHandler) {
					window.removeEventListener('mousemove', this.watermarkPreview.resizeMoveHandler);
				}
				if (this.watermarkPreview.resizeUpHandler) {
					window.removeEventListener('mouseup', this.watermarkPreview.resizeUpHandler);
				}
				if (!this.watermarkPreview.dragging) {
					document.body.style.userSelect = '';
				}
			},
			rangKey(type){
				const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
				    let key = '';
				    for (let i = 0; i < 32; i++) {
				      key += chars.charAt(Math.floor(Math.random() * chars.length));
				    }
					
					if(type==1){
						this.form.zKey = key
					}else if(type==2){
						this.form.fKey = key
					}else{
						this.form.back_key = key
					}
				
				    
			},
			getLiveUrl(){
				if(!this.urlData.stream_name){
					this.$message.error(this.$t('live.inpStreamName'));
					return false
				}
				if(this.urlData.type!=1){
					if(!this.urlData.model_name){
						this.$message.error(this.$t('live.seltranModel'));
						return false
						
					}
				}
				
				this.urlData.load = true;
				this.urlData.id = this.info.id
				this.axios.post('/admin/data/getLiveUrl', this.urlData, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					
					console.log(list)
					
					this.urlShow = list
					
					
					
					this.urlData.load = false;
					
				}).catch(err => {
					
					// 失敗
					this.urlData.load = false;
				})
			},
			 
			againGetHttps(item) {
				
				this.$confirm(this.$t('live.isagainCert'), this.$t('system.prompt'), {
					confirmButtonText: this.$t('system.confirm'),
					cancelButtonText: this.$t('system.cancel'),
					type: 'warning'
				}).then(() => {
					this.layout.loading = true;
					this.axios.post('/admin/data/againGetHttps', {
						id: item.id,
					}, {
						token: true
					}).then(res => {
						let all = res.data;

						this.getList()
					
						this.layout.loading = false;
					}).catch(err => {
						this.layout.loading = false;
					})
				})
				
				
				
			},
			editInfo() {
				this.layout.loading = true;
				this.axios.post('/admin/data/editLiveDomainInfo', this.form, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					
					console.log(list)
					if(this.urlShow.status==1){
						this.getLiveUrl()
					}
					
					
					
					this.layout.loading = false;
					this.createModel = false
					this.getList()
				}).catch(err => {
					
					// 失敗
					this.layout.loading = false;
				})
			},
			
			
			//提交
			submit() {
	
				this.$refs.form.validate(res => {
			
					if (res) {
						
						if(this.openType ==1){
							this.form.id = this.editIndex
							this.addOrEdit(this.form)
							
							this.urlShow.status = 0
						}else{
							this.editInfo()
						}
						
						// 關閉模态框
					}
				})
			},
			
		
			// 打开模态框
			openModel(e = false,type) {
				this.openType = type
				if(type==10){
					
					this.form = {
						id:e.id,
						type:type,
						selIds:[]
						
					}
					this.reloadData('ztran')
				}
				if(type==9){
					
					this.form = {
						id:e.id,
						type:type,
						selIds:[]
						
					}
					this.reloadData()
				}
				if(type==8){
					//录制配置
					this.form = {
						id:e.id,
						type:type,
						selIds:[]
						
					}
					this.reloadData('record')
					
				}
				if(type==7){
					//截图配置
					this.form = {
						id:e.id,
						type:type,
						img_status:e.img_status==1?true:false,
						img_time:e.img_time,
						
					}
					
				}
				if(type==6){
					//https配置
					this.form = {
						id:e.id,
						type:type,
						cert_status:e.cert_status?true:false,
						
					}
					
				}
				if(type==12){
					this.form = {
						id:e.id,
						type:type,
						fileDel_time:e.fileDel_time,
						
					}
					
				}
				
				if(type==13){
					this.form = {
						id:e.id,
						sy_status:e.sy_status?true:false,
						type:type,
						sy:e.sy_sy,
						sy_url:e.sy_url,
						sy_x:this.normalizeWatermarkValue(e.sy_x, 0),
						sy_y:this.normalizeWatermarkValue(e.sy_y, 0),
						sy_scale:this.normalizeWatermarkValue(e.sy_scale, 100, 1, 100),
						sy_scale_w:Number(e.sy_scale_w) || 0,
						sy_w:Number(e.sy_w) || 0,
						sy_h:Number(e.sy_h) || 0,
						preview_width:Number(e.preview_width) || 1920,
						preview_height:Number(e.preview_height) || 1080

						
					}
					this.watermarkPreview.dragging = false
					this.watermarkPreview.dragOffsetX = 0
					this.watermarkPreview.dragOffsetY = 0
					this.watermarkPreview.naturalWidth = 0
					this.watermarkPreview.naturalHeight = 0
					this.syncWatermarkWidthScale()
					
				}
				if(type==11){
					this.form = {
						id:e.id,
						type:type,
						fileRef_status:e.fileRef_status==1?true:false,
						fileRef_null_status:true,
						fileRef_type:e.fileRef_type,
						fileRef_data:e.fileRef_data
					}
				}
				if(type==5){
					this.form = {
						id:e.id,
						type:type,
						ref_status:e.ref_status==1?true:false,
						ref_null_status:e.ref_null_status==1?true:false,
						ref_type:e.ref_type,
						ref_data:e.ref_data
					}
				}
				if(type==4){
					console.log(e)
					this.form = {
						id:e.id,
						type:type,
						ip_status:e.ip_status==1?true:false,
						ip_type:e.ip_type,
						ip_data:e.ip_data2
					}
				}
				if(type==3){
					this.form = {
						id:e.id,
						type:type,
						back_status:e.back_status==1?true:false,
						back_key_status:e.back_key_status==1?true:false,
						back_key:e.back_key,
						
						streamStartStatus:e.streamStartStatus==1?true:false,
						streamStartUrl:e.streamStartUrl,
						
						streamEndStatus:e.streamEndStatus==1?true:false,
						streamEndUrl:e.streamEndUrl,
						
						imgStatus:e.imgStatus==1?true:false,
						imgUrl:e.imgUrl,
						
						recordFileStatus:e.recordFileStatus==1?true:false,
						recordFileUrl:e.recordFileUrl,
						
						recordStatusStatus:e.recordStatusStatus==1?true:false,
						recordStatusUrl:e.recordStatusUrl,
						
					}
				}
				if(type==2){
					//鉴权配置
					this.form = { 
						type:type,
						id:e.id,
						time:e.time,
						zKey:e.zKey,
						fKey:e.fKey,
						agree:false,
						url_auth:e.url_auth==1?true:false,
						
					}
					console.log(e)
					this.editIndex = e.id 
				}
				
				//修改
				if(type==1){
					// 增加
					//console.log(e)
					if (!e) {
						// 初始化表單
						
						this.editIndex = -1
					} else {
						console.log(e)
						// 修改
						this.form = {
							id:e.id,
							user_name:e.user_name,
							uid:e.uid,
							cloud_id:e.cloud_id,
							cloud_name:e.cloud_name,
							uid:e.uid,
							user_name:e.user_name,
							remark:e.remark,
							sort:e.sort,
							user_status:e.user_status,
							type:e.type,
							bind_id:e.bind_id,
							up_regoin:e.up_regoin,
						}
						this.editIndex = e.id
						
						if(e.type==2){
							this.commonList('tlDomain',e.id);
						}
					}
					
					
				}
				
				// 打开dialog
				this.createModel = true
				
			},
			//公共列表
			commonList(type,id=0) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
					id:id
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					
					if(type=='liveDomain'){
						this.agentData = list
					}else{
						this.agentData.tl = list.tl
					}
					
					
					
					this.layout.loading = false;
				}).catch(err => {
					
					// 失敗
					this.layout.loading = false;
				})
			},
			handleAvatarSuccess(res, file) {
				this.form.sy = URL.createObjectURL(file.raw);
				this.form.sy_scale_w = 0;
				this.form.sy_w = 0;
				this.form.sy_h = 0;
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.sy_url = res.encryption.data.list.url
				}
			  },
			beforeAvatarUpload(file) {
				console.log(file.type)
					const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
					const isLt2M = file.size / 1024 / 1024 < 2;
			
					if (!isJPG) {
					  this.$message.error('水印图片请选择JPG 或PNG格式');
					}
					if (!isLt2M) {
					  this.$message.error('水印图片不能大于 2MB!');
					}
					return isJPG && isLt2M;
			},
			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.info = e.info
				this.urlData.time = this.info.time
				console.log(e)
				
				// this.check_img_list = e.list.map(item=>{
				// 	return item.head
				// })
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					username:'',
					status:-1,
					get_status:-1,
					type:-1,
					cloud_id:-1,
					time:[],
				}
			
				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style >
.custom-dialog {
  z-index: 3000!important; /* 设置更高的 z-index */
}

.el-descriptions-item__container {
    display: flex;
    align-items: flex-end;
	height: 35px;
}

.body_head{
	font-weight: bold;
	font-size: 15px;
}

.my-label{
	color: #999;
	width: 130px;
}

.my-con{
	color: #000;
}

.call_tis{
	background-color: #f4f4f5;
	border-color: #e9e9eb;
	color: #909399;
	padding: 10px;
	border-radius: 5px;
	line-height: 22px;
}

.new_show_form .el-form-item__label{
	color: #999;
	font-weight: 400;
	font-size: 14px !important;
	
}
.new_show_form .el-form-item{
	margin-bottom: 0;
}


.ztran_table .el-table__header-wrapper .el-checkbox {
  display: none !important;
}

.table-title {
  margin: 18px 0 8px;
  font-size: 14px;
  color: #303133;
  font-weight: 600;
}

.watermark-editor {
	display: flex;
	align-items: flex-start;
	gap: 32px;
}

.watermark-editor__controls {
	flex: 1;
	min-width: 0;
	padding-right: 8px;
}

.watermark-editor__tip {
	margin-bottom: 12px;
	padding: 10px 12px;
	line-height: 1.6;
	font-size: 12px;
	color: #e6a23c;
	background: #fdf6ec;
	border: 1px solid #faecd8;
	border-radius: 4px;
}

.watermark-editor__preview {
	width: 460px;
	max-width: 100%;
	padding-left: 32px;
	border-left: 1px solid #ebeef5;
}

.watermark-uploader {
	display: inline-block;
}

.watermark-uploader .el-upload {
	width: auto;
}

.watermark-uploader__inner {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: 10px;
	min-width: 180px;
	min-height: 92px;
	padding: 12px 18px;
	border: 1px dashed #dcdfe6;
	border-radius: 8px;
	background: #fafafa;
	cursor: pointer;
	transition: border-color 0.2s ease, background-color 0.2s ease;
}

.watermark-uploader__inner:hover {
	border-color: #409EFF;
	background: #f5faff;
}

.watermark-uploader__icon {
	font-size: 22px;
	color: #409EFF;
}

.watermark-uploader__text {
	font-size: 14px;
	color: #303133;
}

.watermark-uploader__thumb {
	max-width: 72px;
	max-height: 52px;
	object-fit: contain;
	border-radius: 4px;
}

.watermark-slider {
	display: flex;
	align-items: center;
	gap: 16px;
}

.watermark-slider .el-slider {
	flex: 1;
	margin-right: 0;
}

.watermark-slider__value {
	width: 72px;
	color: #606266;
	text-align: right;
	font-variant-numeric: tabular-nums;
}

.watermark-scale {
	display: flex;
	align-items: center;
	gap: 16px;
}

.watermark-scale .el-slider {
	flex: 1;
	margin-right: 0;
}

.watermark-scale .el-input-number {
	width: 140px;
}

.watermark-scale__unit {
	color: #606266;
	font-size: 14px;
}

.watermark-preview__toolbar {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 16px;
	margin-bottom: 14px;
}

.watermark-preview__title {
	font-size: 16px;
	font-weight: 600;
	color: #303133;
}

.watermark-preview__size {
	display: flex;
	align-items: center;
	gap: 10px;
}

.watermark-preview__size-label,
.watermark-preview__size-sep {
	color: #606266;
	font-size: 14px;
}

.watermark-preview__size .el-input-number {
	width: 128px;
}

.watermark-preview {
	display: flex;
	align-items: center;
	justify-content: center;
	max-width: 100%;
	padding: 14px;
	border-radius: 12px;
	background: linear-gradient(180deg, #f7f9fc 0%, #eef2f7 100%);
}

.watermark-preview__screen {
	position: relative;
	overflow: hidden;
	width: 100%;
	height: 100%;
	border: 1px solid #dfe6ee;
	border-radius: 10px;
	background:
		linear-gradient(90deg, rgba(255,255,255,0.22) 1px, transparent 1px),
		linear-gradient(rgba(255,255,255,0.22) 1px, transparent 1px),
		#dde3ea;
	background-size: 32px 32px, 32px 32px, auto;
	box-shadow: inset 0 1px 0 rgba(255,255,255,0.6);
}

.watermark-preview__image {
	display: block;
	width: 100%;
	height: 100%;
	object-fit: contain;
	cursor: move;
	user-select: none;
	box-shadow: 0 8px 18px rgba(15, 23, 42, 0.18);
}

.watermark-preview__image-box {
	position: absolute;
	left: 0;
	top: 0;
	transform-origin: top left;
}

.watermark-preview__handle {
	position: absolute;
	width: 12px;
	height: 12px;
	background: #409EFF;
	border: 2px solid #ffffff;
	border-radius: 2px;
	box-shadow: 0 2px 8px rgba(64, 158, 255, 0.35);
	z-index: 2;
}

.watermark-preview__handle.is-top-left {
	left: -6px;
	top: -6px;
	cursor: nwse-resize;
}

.watermark-preview__handle.is-top-right {
	right: -6px;
	top: -6px;
	cursor: nesw-resize;
}

.watermark-preview__handle.is-bottom-left {
	left: -6px;
	bottom: -6px;
	cursor: nesw-resize;
}

.watermark-preview__handle.is-bottom-right {
	right: -6px;
	bottom: -6px;
	cursor: nwse-resize;
}

.watermark-preview__empty {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
	padding: 24px;
	font-size: 14px;
	color: #909399;
	text-align: center;
}

@media (max-width: 1200px) {
	.watermark-editor {
		flex-direction: column;
	}

	.watermark-editor__preview {
		width: 100%;
		padding-left: 0;
		padding-top: 24px;
		border-left: 0;
		border-top: 1px solid #ebeef5;
	}
}

@media (max-width: 768px) {
	.watermark-preview__toolbar {
		flex-direction: column;
		align-items: flex-start;
	}

	.watermark-preview__size {
		flex-wrap: wrap;
	}

	.watermark-slider,
	.watermark-scale {
		flex-direction: column;
		align-items: stretch;
	}

	.watermark-slider__value {
		width: auto;
		text-align: left;
	}
}

.refov{
	max-height: 200px;overflow-y: auto; background: #f2f3f8;
	padding:0px 10px 10px;
	line-height: 22px;
	width: 400px;
}

</style>
